import {AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {MatTabGroup} from "@angular/material/tabs";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AbstractControl, FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FormService} from "@core/shared/services/form.service";
import {Currency} from "@core/shared/models/currency";
import {CurrencyService} from "@core/shared/services/currency.service";
import {OfferPriceTypeType} from "@core/shared/models/offer/offer-price-type";
import {OfferPricePublicType} from "@core/shared/models/offer/offer-price-public";
import {OfferCircuitType, OfferLocation, OfferLocationDirection, OfferLocationTranslation} from "@core/shared/models/offer/offer-location";
import {LOCALE_ITEMS, LocaleItem, TranslationBuilder, TranslationItem} from '@core/shared/models/translation';
import ClassicEditor from "@lib/ckeditor";
import {CkeditorConfig} from "@lib/form/fields/ckeditor/ckeditor.component";
import {TranslateService} from "@ngx-translate/core";
import {OfferPresential} from "@core/shared/models/offer/offer-presential";
import {OfferService} from '@core/shared/services/offer.service';
import {CustomerTypology} from '@core/shared/models/customer-typology';
import {BehaviorSubject, forkJoin, Observable, of, Subject} from 'rxjs';
import {CustomerTypologyService} from '@core/shared/services/customer-typology.service';
import {TextFilterField} from '@core/shared/models/filter/text-filter-field';
import {OfferDuration} from '@core/shared/models/offer/offer-duration';
import {OfferDurationService} from '@core/shared/services/offer/offer-duration.service';
import {Society} from '@core/shared/models/society';
import {SocietyService} from '@core/shared/services/society.service';
import {Offer, OFFER_WITHOUT_NIGHT, OfferGiftVoucherConfiguration, OfferOnlineSaleConfiguration, OfferStockType, OfferTranslation, OfferTranslationPicture} from '@core/shared/models/offer';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ImageConfig} from "@lib/form/fields/image/image.component";
import {ApiService} from "@core/shared/services/api.service";
import {ConfirmDialogComponent} from '@lib/confirm-dialog/confirm-dialog.component';
import {LOCALE_PUBLISHED_ITEMS, LocalePublishedItem} from '@core/shared/models/published';
import {FieldCollection} from '@lib/form/field';
import {offerAttributesValidator} from "@core/shared/validators/offer/offer-attributes.validator";
import {OfferIncluded} from "@core/shared/models/offer/offer-included";
import {Access} from "@core/shared/models/access";
import {User} from "@core/shared/models/user";
import {UserService} from "@core/shared/services/user.service";
import {OfferOptionService} from "@core/shared/services/offer/offer-option.service";
import {OfferOption} from "@core/shared/models/offer/offer-option";
import {FilterBuilder} from "@core/shared/models/filter";
import {ArrayFilterField} from "@core/shared/models/filter/array-filter-field";
import {FormTabValidationItem, OfferFormTabValidationService} from "@core/shared/services/form/form-tab-validation.service";
import {OfferLocationFormComponent} from "@core/components/offer/offer-location/offer-location-form/offer-location-form.component";
import {DEFAULT_MARKUP, MIN_MARKUP} from '@core/shared/models/data';
import {REGEX_PRICE, REGEX_SLUG} from "@core/shared/models/regex";
import {OfferSeo, OfferSeoTranslation} from "@core/shared/models/offer/offer-seo";
import {
    offerPresentialAdultDefaultValidator,
    offerPresentialAdultIncrementalStepValidator,
    offerPresentialChildDefaultValidator,
    offerPresentialChildIncrementalStepValidator
} from "@core/shared/validators/offer/offer-presential.validator";
import {TranslationService} from "@core/shared/services/translation.service";
import {DragAndDropService} from "@core/shared/services/drag-and-drop.service";
import {OfferProgram, OfferProgramTranslation} from "@core/shared/models/offer/offer-program";
import {GiftVoucherType, OFFER_GIFTVOUCHER_TYPES, VoucherType} from "@core/shared/models/gift-voucher/gift-voucher-type";
import {OfferLocationProvider} from "@core/shared/models/offer/offer-location/offer-location-provider";
import {parseMarkup} from "@core/shared/utils/markup";
import {OfferTranslationRequest} from "@core/shared/models/offer/offer-translation-request";
import {Card} from "@core/shared/models/card";
import {CardService} from "@core/shared/services/card.service";
import {OfferTranslationService} from "@core/shared/services/offer/offer-translation.service";
import {OfferInterest} from "@core/shared/models/offer/offer-interest";
import {OfferTranslationFailedDialogComponent} from "@core/components/offer/offer-translation/offer-translation-failed/offer-translation-failed-dialog/offer-translation-failed-dialog.component";
import {TermsAndCondition, TermsAndConditionTranslation} from "@core/shared/models/terms-and-condition";
import {Image} from "@lib/media/image/image";
import {ImageService} from "@lib/media/image/image.service";
import {ImageEventService} from "@lib/media/image/image.event.service";
import {TranslationPictureType} from "@core/shared/models/translation/translation-picture";
import {map, mergeMap, skip, tap} from "rxjs/operators";
import {OfferCatalog} from "@core/shared/models/offer/offer-catalog";
import {OfferCatalogService} from "@core/shared/services/offer/offer-catalog.service";
import {Pagination} from "@core/shared/models/pagination";
import {FormPanel} from "@core/shared/models/form/form-panel";
import {Transport, TransportType} from "@core/shared/models/transport";
import {OfferLocationTransport} from "@core/shared/models/offer/offer-location/offer-location-transport";
import {TransportCalculation} from "@core/shared/models/transport/transport-calculation";
import {AdditionalHeader} from "@core/shared/models/http-client";
import {DEACTIVATE_LOADER_HEADER_IDENTIFIER} from "@app/data";
import {TransportService} from "@core/shared/services/transport.service";
import {parsePrice} from '@core/shared/utils/price';

type FormPanelTag = 'accessProgramStart' | 'accessProgramEnd' | 'accessDisplayOption' | 'accessCompatibilityWithoutCar';

@Component({
    selector: 'app-core-page-offer-update',
    templateUrl: './page-offer-update.component.html',
    styleUrls: ['./page-offer-update.component.scss'],
    providers: [
        FormService,
        OfferFormTabValidationService,
        OfferService
    ],
    standalone: false
})
export class PageOfferUpdateComponent implements OnInit, AfterViewInit, AfterContentInit {

    @ViewChild('tabGroup', {static: true}) tabGroup: MatTabGroup;

    @ViewChild('generalData', {static: true}) generalDataRef: TemplateRef<any>;

    @ViewChild('contentManagement', {static: true}) contentManagementRef: TemplateRef<any>;

    @ViewChild('programData', {static: true}) programDataRef: TemplateRef<any>;

    @ViewChild('providerData', {static: true}) providerDataRef: TemplateRef<any>;

    @ViewChild('characteristicData', {static: true}) characteristicDataRef: TemplateRef<any>;

    @ViewChild('locationData', {static: true}) locationDataRef: TemplateRef<any>;

    @ViewChild('access', {static: false}) accessRef: TemplateRef<any>;

    @ViewChild('seoManagement', {static: true}) seoManagementRef: TemplateRef<any>;

    @ViewChild('internalComments', {static: true}) internalCommentsRef: TemplateRef<any>;

    //@ViewChild('options', {static: true}) optionsRef: TemplateRef<any>;

    @ViewChild('pricingData', {static: true}) pricingDataRef: TemplateRef<any>;

    @ViewChild('giftVoucherData', {static: true}) giftVoucherDataRef: TemplateRef<any>;

    @ViewChildren(OfferLocationFormComponent) offerLocationFormComponents: QueryList<OfferLocationFormComponent>;

    @ViewChild('enableAutomaticTranslationReference', { static: false }) enableAutomaticTranslationReference: ElementRef<HTMLDivElement>;

    @ViewChild('sourceLocaleDescriptionReference', { static: false }) sourceLocaleDescriptionReference: ElementRef<HTMLDivElement>;

    @ViewChild('destinationLocalesDescriptionReference', { static: false }) destinationLocalesDescriptionReference: ElementRef<HTMLDivElement>;

    @ViewChild('translationRequestSummaryReference', { static: false }) translationRequestSummaryReference: ElementRef<HTMLDivElement>;

    protected readonly OfferLocationDirection = OfferLocationDirection;

    public panels: FormPanel<FormPanelTag>[] = [];

    public offer: Offer;

    public offerId: number;

    public currencies: Currency[] = [];

    public minMarkupPercent: number = MIN_MARKUP;

    public defaultMarkupPercent: number = DEFAULT_MARKUP;

    public translationBuilder: TranslationBuilder;

    public seoTranslationBuilder: TranslationBuilder;

    public locationTranslationBuilders: TranslationBuilder[] = [];

    public editor = ClassicEditor;

    public presentialMax: number = 99;

    public customerTypologies: CustomerTypology[] = [];

    public customerTypologyType: string = '';

    public id: number = 0;

    public limitProgram: number = 0;

    public limitLocation: number = 3;

    public defaultOfferLocales: string[] = [];

    public locales$: BehaviorSubject<{ item: LocaleItem, enabled: boolean }[]> = new BehaviorSubject<{item: LocaleItem; enabled: boolean}[]>([]);

    public publishes$: Observable<LocalePublishedItem[]>;

    public society: Society;

    public fieldCollection = new FieldCollection();

    public offerDurations: Object[] = [];

    public formSubmitSubscription: Subject<object> = new Subject<object>();

    public attributesFormReference: UntypedFormGroup;

    public user: User;

    public options$: Observable<OfferOption[]>;

    public tabItems: { tag: string, label: string, template: TemplateRef<any> }[] = [];

    public submitEnabled: boolean = true;

    public saveAndRedirectConfiguration: { active: boolean, target: ('availabilities') } = {
        active: false,
        target: null
    };

    public enableAutomaticTranslation: boolean = false;

    public enableAutomaticTranslationUpdated$: Subject<void> = new Subject();

    public sourceLocales$: BehaviorSubject<{ item: LocaleItem, enabled: boolean }[]> = new BehaviorSubject<{item: LocaleItem; enabled: boolean}[]>([]);

    public destinationLocales$: BehaviorSubject<{ item: LocaleItem, enabled: boolean }[]> = new BehaviorSubject<{item: LocaleItem; enabled: boolean}[]>([]);

    public automaticTranslationSourceLocale: string = null;

    public automaticTranslationSourceLocaleUpdated$: Subject<void> = new Subject();

    public automaticTranslationDestinationLocales: string[] = [];

    public automaticTranslationDestinationLocalesUpdated$: Subject<void> = new Subject();

    public translationRequestSummary$: BehaviorSubject<OfferTranslationRequest> = new BehaviorSubject<OfferTranslationRequest>({
        totalPriceTTC: 0
    });

    public card: Card;

    public addedToCatalog: boolean = false;

    public selectedAccessTransportTypes: TransportType[] = [];

    public transportOfferLocationsControl: FormGroup;

    public arrivalOfferLocationControl: FormGroup = null;

    public departureOfferLocationControl: FormGroup = null;

    public transportDisplayedConfiguration: { [p in OfferLocationDirection]: boolean } = {
        [OfferLocationDirection.Arrival]: false,
        [OfferLocationDirection.Departure]: false
    };

    public transportCalculations: OfferLocationTransport[] = [];

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _formBuilder: UntypedFormBuilder,
        private _dialog: MatDialog,
        private _changeDetectorRef: ChangeDetectorRef,
        public formService: FormService,
        private _translateService: TranslateService,
        private _currencyService: CurrencyService,
        private _customerTypologyService: CustomerTypologyService,
        private _offerDurationService: OfferDurationService,
        private _societyService: SocietyService,
        private _snackBar: MatSnackBar,
        private _router: Router,
        private _offerOptionService: OfferOptionService,
        private _offerTranslationService: OfferTranslationService,
        private _cardService: CardService,
        private _imageService: ImageService,
        private _imageEventService: ImageEventService,
        private _offerCatalogService: OfferCatalogService,
        private _transportService: TransportService,
        public offerService: OfferService,
        public dragDropService: DragAndDropService,
        public offerFormTabValidationService: OfferFormTabValidationService,
        public apiService: ApiService,
        public _userService: UserService,
        public translationService: TranslationService
    ) {
    }

    ngOnInit(): void {

        this.user = this._userService.currentUser.value;

        this.attributesFormReference = this._formBuilder.group({});

        this._initForm();

        this._initSelectForm();

        this._initOfferCreator();

        this._initLocales();

        this._initCustomerTypologies();

        this._activatedRoute.params.subscribe(params => {

            this.offerId = params['id'];
        });

        this._activatedRoute.data.subscribe((data: { user: User, offer: Offer, society: Society, durations: OfferDuration[] }): void => {

            this._userService.currentUser.next(data.user);

            this.user = this._userService.currentUser.value;

            data.durations.forEach((duration: OfferDuration, index: number): void => {

                this.offerDurations[index] = Object.assign(duration, {
                    name: this.translationService.getFallbackTranslation(duration.translations).label
                });
            });

            this.offer = data.offer;

            this.defaultOfferLocales = [...data.offer.locales];

            this.society = data.society;

            this._initPublishes();

            if(this.hasAccessAutomaticTranslation){

                this._initCard();
            }

            if(this.hasAccessGiftVoucher) {

                const offerGiftVoucher: OfferGiftVoucherConfiguration = data.offer.giftVoucher ? {...data.offer.giftVoucher} : this.defaultGiftVoucher;

                Object.assign(data.offer, {
                    enableGiftVoucher: data.offer.giftVoucher ? data.offer.giftVoucher.enable : false,
                    giftVoucher: Object.assign(offerGiftVoucher, {
                        adultPriceTTC: !!offerGiftVoucher.adultPriceTTC ? (offerGiftVoucher.adultPriceTTC / 100) : null,
                        childPriceTTC: !!offerGiftVoucher.childPriceTTC ? (offerGiftVoucher.childPriceTTC / 100) : null
                    })
                });

                if(data.offer.giftVoucher){

                    this._hydrateGiftVoucherType();
                }

                const offerOnlineSale: OfferOnlineSaleConfiguration = data.offer.onlineSale ? {...data.offer.onlineSale} : this.defaultOnlineSale;

                Object.assign(data.offer, {
                    enableOnlineSale: offerOnlineSale.enable,
                    stockManagementType: offerOnlineSale.stockManagementType
                })
            }

            this._cleanRestrictedSocieties(data.offer);

            this.form.patchValue(data.offer);

            this.form.get('options').patchValue(data.offer.options.map((option: OfferOption): number => {

                return option.id;
            }));

            this.limitProgram = data.offer.duration.limitProgram;

            this.limitLocation = data.offer.duration.limitLocation;

            this.form.get('limitLocation').setValue(this.limitLocation);

            this.customerTypologyType = data.offer.customerTypology.type;

            const societyTermsAndCondition: TermsAndCondition = this.user.society.termsAndConditions.find((termsAndCondition: TermsAndCondition): boolean => {

                return termsAndCondition.typology.id === parseInt(this.form.get('customerTypology').value.id);
            });

            const societyTermsAndConditionLocales: string[] = societyTermsAndCondition.translations.map((translation: TermsAndConditionTranslation): string => {

                return translation.locale;
            });

            this.locales$.next(LOCALE_ITEMS.map((localeItem : LocaleItem): { item: LocaleItem, enabled: boolean } => {

                return {
                    item: localeItem,
                    enabled: societyTermsAndConditionLocales.includes(localeItem.id)
                };
            }));

            if(data.offer.configuration.orchestra){

                this.presentialControl.get('adultIncrementalStep').disable();

                this.presentialControl.get('childIncrementalStep').disable();

                this.presentialControl.get('adultMin').patchValue(1);

                this.presentialControl.get('adultMin').disable();

                this.presentialControl.get('childMin').patchValue(0);

                this.presentialControl.get('childMin').disable();

                this.form.get('enableOnlineSale').disable();

                this.form.get('onRequest').disable();
            }

            if(data.offer.vatPercent){

                this.form.get('vatPercent').patchValue(data.offer.vatPercent * 100);
            }

            if(data.offer.markup){

                this.form.get('markup').patchValue(parseMarkup(data.offer.markup * 100));
            }

            if(data.offer.internalStartFromPriceTTC){

                this.form.get('internalStartFromPriceTTC').patchValue(parsePrice(data.offer.internalStartFromPriceTTC / 100, 2, ''));
            }

            this._loadOptions();

            this._initCurrencies();

            // Initialisation de la location

            this.offerService.providersSocieties$.next(data.offer.providerSocieties);

            this.locationsControl.removeAt(0);

            data.offer.locations.forEach((location: OfferLocation): void => {

                this.locationsControl.push(this.createLocationGroup(Object.assign(location, {
                    providers: (location.providers as unknown as OfferLocationProvider[]).map((offerLocationProvider: OfferLocationProvider): Society => {

                        return offerLocationProvider.provider;
                    })
                })));
            });

            // Initialisation des transports

            const transportTypes: TransportType[] = ['train-station', 'airport'];

            transportTypes.forEach((item: TransportType): void => {

                if(this.hasLocationsWithTransportType(item)){

                    this.selectedAccessTransportTypes.push(item);
                }
            });

            this.form.get('startLocationSameAsEndLocation').patchValue(this.isStartLocationSameAsEndLocation);

            if(this.arrivalOfferLocation){

                this.arrivalOfferLocationControl = this.locationsControl.controls.find((control: FormGroup): boolean => {

                    return control.get('position').value === this.arrivalOfferLocation.position;

                }) as FormGroup;

                this.updateTransportDisplayState(OfferLocationDirection.Arrival, true);
            }

            if(!this.isStartLocationSameAsEndLocation && this.departureOfferLocation){

                this.departureOfferLocationControl = this.locationsControl.controls.find((control: FormGroup): boolean => {

                    return control.get('position').value === this.departureOfferLocation.position;

                }) as FormGroup;

                this.updateTransportDisplayState(OfferLocationDirection.Departure, true);
            }

            this._resetLocationsControlValidation();

            this._initTranslations();

            this._initSeoTranslations(data.offer.seo);

            data.offer.translations.forEach((translation: OfferTranslation): void => {

                const group: UntypedFormGroup = this.translationBuilder.addItemControl(this.translationBuilder.getLocaleItem(translation.locale), translation);

                group.addControl('id', this._formBuilder.control(translation.id));

                translation.pictures.forEach((picture: OfferTranslationPicture): void => {

                    (group.get('pictures') as UntypedFormArray).push(this._formBuilder.group({
                        id: [picture.id],
                        copyright: [picture.copyright, [Validators.required]],
                        image: this._formBuilder.group({
                            image: [picture.image.image, [Validators.required]],
                            id: [picture.image.id, [Validators.required]]
                        }),
                        position:[picture.position, [Validators.required]]
                    }));
                });
            });

            this.form.get('hasProgramsPictures').patchValue(this._offerHasPictures());

            this.sourceLocales$.next(this.locales$.getValue().map((locale: { item: LocaleItem, enabled: boolean }): { item: LocaleItem, enabled: boolean } => {

                return {
                    item: locale.item,
                    enabled: this.form.get('locales').value.includes(locale.item.id)
                };
            }));

            this.offerService.displayedLocales$.next(this.form.get('locales').value);

            this._handleTranslationControls();

            this._handlePresentialControls(false);

            this._updateCurrencyValidators(false);

            this._patchGiftVoucher();

            this._handleFormState();

            this.form.updateValueAndValidity();

            this._initFormEvents();

            this._initPanels();
        });
    }

    ngAfterViewInit(): void {

        this._initTabItems();

        setTimeout((): void => {

            this.offerFormTabValidationService.init(this.tabGroup, this.form, this.formTabValidationItemsCallback);
        });

        this.offerLocationFormComponents.changes.subscribe((): void => {

            setTimeout((): void => {

                this.offerLocationFormComponents.forEach((component: OfferLocationFormComponent): void => {

                    component.expensionPanel.expanded = false;
                });

                this.offerLocationFormComponents.last.expensionPanel.expanded = true;
            });
        });
    }

    ngAfterContentInit() {

        this._changeDetectorRef.detectChanges();
    }

    private _initCard(): void {

        this._cardService.getSocietyItem(this.user.society.id).subscribe((item: Card|null): void => {

            this.card = item;
        });
    }

    private _initTabItems(): void {

        this.tabItems = [];

        this.tabItems.push(...[
            {
                tag: 'generalData',
                label: 'offer.generalData.value',
                template: this.generalDataRef
            },
            {
                tag: 'contentManagement',
                label: 'offer.contentManagement.value',
                template: this.contentManagementRef
            },
            {
                tag: 'programData',
                label: 'offer.programData.value',
                template: this.programDataRef
            },
            {
                tag: 'characteristicData',
                label: 'offer.characteristicData.value',
                template: this.characteristicDataRef
            },
            {
                tag: 'providerData',
                label: 'offer.providerData.value',
                template: this.providerDataRef
            },
            {
                tag: 'locationData',
                label: 'offer.location.data.value',
                template: this.locationDataRef
            }
        ]);

        if(!this.offer.enableMultipleMainLocation){

            this.tabItems.push({
                tag: 'access',
                label: 'offer.access.value',
                template: this.accessRef
            });
        }

        this.tabItems.push(...[
            {
                tag: 'seoManagement',
                label: 'offer.seoManagement.value',
                template: this.seoManagementRef
            },
            {
                tag: 'internalComments',
                label: 'offer.internalComments.value',
                template: this.internalCommentsRef
            },
            /**{
                tag: 'options',
                label: 'offer.options.value',
                template: this.optionsRef
            },**/
            {
                tag: 'pricingData',
                label: 'offer.pricingData.value',
                template: this.pricingDataRef
            }
        ]);

        if (this.hasAccessGiftVoucher) {

            this.tabItems.push({
                tag: 'giftVoucherData',
                label: 'offer.onlineSale.value',
                template: this.giftVoucherDataRef
            });
        }
    }

    private _initPanels(): void {

        const items: { tag: FormPanelTag, controls: AbstractControl[] }[]  = [
            {
                tag: 'accessProgramStart',
                controls: [

                ]
            },
            {
                tag: 'accessProgramEnd',
                controls: [

                ]
            },
            {
                tag: 'accessDisplayOption',
                controls: [

                ]
            },
            {
                tag: 'accessCompatibilityWithoutCar',
                controls: [

                ]
            }
        ];

        this.panels = items.map((item: FormPanel<FormPanelTag>, index: number): FormPanel<FormPanelTag> => {

            return Object.assign(item, {
                valid: false,
                open: index === 0
            } as Partial<FormPanel<FormPanelTag>>);
        });

        this._updatePanelsValidation();
    }

    private _updatePanelsValidation(): void {

        this.panels.forEach((item: FormPanel<FormPanelTag>): void => {

            item.valid = item.controls.every((control: AbstractControl): boolean => {

                return control.valid;
            });
        });
    }

    private _loadOptions(): void {

        const filterBuilder = new FilterBuilder();

        (this.form.get('locales').value as string[]).forEach((locale: string): void => {

            filterBuilder.addField(new ArrayFilterField('locales', 'andlkin', locale));
        });

        this.options$ = this._offerOptionService.getItemsAPI(this.society.id, filterBuilder.serializedFilters);
    }

    private _hydrateGiftVoucherType(): void {

        if(!this.hasAccessGiftVoucher){

            return;
        }

        const control: UntypedFormControl = this.form.get('giftVoucher') as UntypedFormControl;

        const types: VoucherType[] = [];

        if (this.offer.giftVoucher.isDematerialized) {

            types.push('isDematerialized');
        }

        if (this.offer.giftVoucher.isPhysical) {

            types.push('isPhysical');
        }

        control.get('types').patchValue(types);
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({

            // Données générales

            publics: [[], [Validators.required]],
            minChildrenAge: [0, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
            maxChildrenAge: [0, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
            reference: [null],
            offerCreator: [''],
            locales: [[], [Validators.required]],
            optinAutomaticTranslation: [false, [(control: UntypedFormControl) => {

                if((!this.translationRequestSummary$.getValue().totalPriceTTC) || control.value){

                    return null;
                }

                return {
                    'isRequired': {
                        valid: false
                    }
                };
            }]],
            duration: this.createDurationGroup({
                id: null,
                limitProgram: 0,
                limitLocation: 0,
                value: null,
                type: null,
                translations: null
            }),

            // Gestion de contenu

            translations: new UntypedFormArray([]),
            interests: new UntypedFormArray([]),
            included: new UntypedFormArray([]),
            trueIncluded: new UntypedFormArray([]),
            falseIncluded: new UntypedFormArray([]),
            translationPictureType: ['common' as TranslationPictureType, [Validators.required]],

            // Données programme

            limitLocation: [this.limitLocation, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
            hasProgramsPictures: [],
            programs: new UntypedFormArray([]),

            // Données prestataires

            providerSocieties: new UntypedFormControl([]),

            // Données caractéristiques

            attributes: new UntypedFormArray([], [offerAttributesValidator(this.attributesFormReference)]),
            customerTypology: this.createCustomerTypologyGroup({
                id: null,
                translations: [],
                type: ''
            }),

            // Données présentiels

            presential: this.createPresentialGroup({
                id: null,
                max: null,
                adultMin: null,
                adultMax: null,
                adultIncrementalStep: null,
                adultDefault: null,
                childMin: null,
                childMax: null,
                childIncrementalStep: null,
                childDefault: null
            }, null),

            // Données localisation

            locations: new UntypedFormArray([]),
            startLocationSameAsEndLocation: [true, [Validators.required]],

            // Type de localisation

            enableMultipleMainLocation: [false, [Validators.required]],
            displayTransportDuration: [false, [Validators.required]],
            isCarFreeCompatible: [false, [Validators.required]],

            // Prestataires global pour les localisations

            providerLocations: new UntypedFormControl([]),

            // Gestion de la publication

            published: [null, [Validators.required]],
            isRestricted: [false, [Validators.required]],
            restrictedSocieties: new UntypedFormControl([]),

            // Gestion du SEO

            seo: this.createSeoGroup({
                id: null,
                follow: true,
                translations: []
            }),

            //  Indication vigilance

            isOnAlert: [false, [Validators.required]],
            commentAlert: [''],

            // Options

            options: [[]],

            // Données tarifaires

            timezone: [null, [Validators.required]],
            onRequest: [false],
            currency: [null],
            internalStartFromPriceTTC: [null, [Validators.pattern(REGEX_PRICE)]],
            startFromPriceBasedOnParticipantCount: [null],
            displayPrice: ['TTC' as OfferPriceTypeType, [Validators.required]],
            priceCalculationAutomatic: [false, [Validators.required]],
            vatPercent: [null, [Validators.pattern(REGEX_PRICE)]],
            allowBookingRequest: [true, [Validators.required]],
            markup: [this.defaultMarkupPercent, [Validators.required, Validators.pattern(REGEX_PRICE), Validators.min(this.minMarkupPercent)]],

            // Vente en ligne
            enableGiftVoucher: [false],
            enableOnlineSale: [false],
            stockManagementType: ['dissociated' as OfferStockType],

            // Circuit - Itinérant
            circuitType: [null, Validators.required],

            // Configuration

            configuration: this._formBuilder.group({
                id: [null, [Validators.required]],
                orchestra: [false, [Validators.required]]
            })
        });

        if(this.hasAccessGiftVoucher){

            this.form.addControl('giftVoucher',this.createGiftVoucherGroup);
        }

        // Validation des localisations

        this._resetLocationsControlValidation();

        // Validation des moyens de transport

        this._initTransportOfferLocationsControl();

        this.form.valueChanges.subscribe((): void => {

            this.formService.showValidationMessages(this.form);
        });

        this.formService.submitCallback = (): void => {

            this._setIncluded();

            for (let i = 0; i < this.form.get('programs').value.length; i++) {

                this.programsControl.controls[i].get('position').patchValue(i + 1);
            }

            let data: Offer = Object.assign(this.form.getRawValue(), {
                customerTypology: {
                    id: (this.customerTypologyControl.getRawValue() as unknown as { id: number }).id
                },
                minChildrenAge: parseInt(this.form.get('minChildrenAge').value),
                maxChildrenAge: parseInt(this.form.get('maxChildrenAge').value),
                currency: this.form.get('currency').value ? {
                    id: parseInt(this.form.get('currency').value)
                } : null,
                internalStartFromPriceTTC: this.form.get('internalStartFromPriceTTC').value ? parseInt((this.form.get('internalStartFromPriceTTC').value * 100).toFixed()) : null,
                vatPercent: this.form.get('vatPercent').value ? (this.form.get('vatPercent').value / 100) : null,
                markup: (parseFloat(this.form.get('markup').value) / 100).toFixed(4),
                included: (this.form.get('included').value as OfferIncluded[]).map((item: OfferIncluded, index: number): OfferIncluded => {

                    return Object.assign(item, {
                        position: index + 1
                    });
                }),
                options: (this.form.get('options').value as number[]).map((id: number): { id: number } => { return { id: id } }),
                locations: (this.form.get('locations').getRawValue() as OfferLocation[]).map((item: OfferLocation) => {

                    const providers: OfferLocationProvider[] = (this.form.get('enableMultipleMainLocation').value && this.geolocationIsAllowed) ? item.providers.map((provider: Society): OfferLocationProvider => {

                        return {
                            provider: provider
                        };
                    }) : [];

                    return Object.assign(item, {
                       providers: providers,
                       isMain:  !!this.form.get('enableMultipleMainLocation').value
                    });

                }),
                restrictedSocieties: this.allRestrictedSocieties.map((item: Society): { id: number } => { return { id: item.id } })
            });

            if(this.hasAccessGiftVoucher) {

                // Configuration du bon cadeau

                data['giftVoucher'] = {
                    enable: this.form.get('enableGiftVoucher').value,
                    adultPriceTTC:  this.giftVoucherControl.get('adultPriceTTC').value ? parseInt((this.giftVoucherControl.get('adultPriceTTC').value * 100).toFixed()) : 0,
                    childPriceTTC: this.giftVoucherControl.get('childPriceTTC').value ? parseInt((this.giftVoucherControl.get('childPriceTTC').value * 100).toFixed()) : 0,
                    isPhysical: this.isSelectedGiftVoucherType('isPhysical'),
                    isDematerialized: this.isSelectedGiftVoucherType('isDematerialized')
                };

                if (this.offer.giftVoucher && this.offer.giftVoucher.id){

                    Object.assign(data['giftVoucher'], {
                        id: this.offer.giftVoucher.id
                    });
                }

                // Configuration de la vente en ligne

                data['onlineSale'] = {
                    enable: this.form.get('enableOnlineSale').value,
                    stockManagementType: this.form.get('stockManagementType').value
                };

                if (this.offer.onlineSale && this.offer.onlineSale.id){

                    Object.assign(data['onlineSale'], {
                        id: this.offer.onlineSale.id
                    });
                }
            }

            data['attributes'] = [];

            for (let i = 0; i < this.attributesControl.length; i++){

                data['attributes'].push(this.attributesControl.value[i]);
            }

            if(!this.form.get('enableMultipleMainLocation').value) {

                data['locations'][0].isMain = true;
            }

            // Filtres sur les langues à traduire manuellement

            data.locales = data.locales.filter((locale: string): boolean => {

                return this.offerService.displayedLocales$.getValue().includes(locale) || (this.defaultOfferLocales.includes(locale) && this.automaticTranslationDestinationLocales.includes(locale));
            });

            data.translations = data.translations.filter((translation: TranslationItem): boolean => {

                return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
            });

            data.interests.forEach((item: OfferInterest): void => {

                item.translations = item.translations.filter((translation: TranslationItem): boolean => {

                    return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
                });
            });

            data.included.forEach((item: OfferIncluded): void => {

                item.translations = item.translations.filter((translation: TranslationItem): boolean => {

                    return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
                });
            });

            data.programs.forEach((item: OfferProgram): void => {

                item.translations = item.translations.filter((translation: TranslationItem): boolean => {

                    return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
                });
            });

            data.locations.forEach((item: OfferLocation): void => {

                item.translations = item.translations.filter((translation: TranslationItem): boolean => {

                    return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
                });
            });

            data.seo.translations = data.seo.translations.filter((translation: TranslationItem): boolean => {

                return this.offerService.displayedLocales$.getValue().includes(translation.locale) || (this.defaultOfferLocales.includes(translation.locale) && this.automaticTranslationDestinationLocales.includes(translation.locale));
            });

            // Cleaning data
            delete data['trueIncluded'];
            delete data['falseIncluded'];
            delete data['enableGiftVoucher'];
            delete data['enableOnlineSale'];
            delete data['providerLocations'];

            this.submitEnabled = false;

            this.offerService.updateItemAPI(Number(this.offerId), data).pipe(
                mergeMap((offer: Offer): Observable<OfferCatalog|Offer> => {

                    if(offer.published !== 'published') {

                        return of(offer);
                    }

                    const params: string[] = [];

                    params.push(`offer.id[eq]=${offer.id}`);

                    return this._offerCatalogService.getPaginationItemsAPI(params).pipe(
                        mergeMap((pagination: Pagination<OfferCatalog>): Observable<Offer> => {

                            if(pagination.totalItems > 0) {

                                return of(offer);
                            }

                            return this._offerCatalogService.createItemAPI({
                                offer: {
                                    id: offer.id
                                },
                                markup: (offer.markup === undefined ? DEFAULT_MARKUP : offer.markup)
                            }).pipe(
                                tap((): void => {

                                    this.addedToCatalog = true;
                                }),
                                map((offerCatalog: OfferCatalog): Offer => {

                                    return offerCatalog.offer;
                                })
                            )
                        })
                    );
                })
            )
            .subscribe((): void => {

                const confirmNotificationCallback = (): void => {

                    this._snackBar.open(this._translateService.instant(this.addedToCatalog ? 'offer.form.action.modifiedAndAutomaticAddition.success.value' : 'offer.form.action.modified.success.value'), this._translateService.instant('notification.close.action.value'), {
                        duration: 20000
                    });
                };

                const postSubmitCallback = (): void => {

                    if(this.saveAndRedirectConfiguration.active){

                        switch (this.saveAndRedirectConfiguration.target){

                            case 'availabilities':

                                this._router.navigate(['account/availability/offer/update', this.offer.id]);

                                break;
                        }
                    }
                    else{

                        this._router.navigate(['account/offer/list/personnal-offers']);
                    }
                };

                if(this.enableAutomaticTranslation && this.automaticTranslationSourceLocale && this.automaticTranslationDestinationLocales.length){

                    // Traduction automatique des langues

                    const automaticTranslationData: { sourceLocale: string, targetLocales: string[] } = {
                        sourceLocale: this.automaticTranslationSourceLocale,
                        targetLocales: this.automaticTranslationDestinationLocales
                    };

                    this._offerTranslationService.requestAPI(this.offer.id, automaticTranslationData).subscribe((): void => {

                        confirmNotificationCallback();

                        postSubmitCallback();

                    }, (): void => {

                        this._dialog.open(OfferTranslationFailedDialogComponent, {
                            width: '500px'
                        });

                        postSubmitCallback();
                    });
                }
                else{

                    confirmNotificationCallback();

                    postSubmitCallback();
                }

            }, (): void => {

                this.saveAndRedirectConfiguration = {
                    active: false,
                    target: null
                };

                this.submitEnabled = true;
            });
        };
    }

    private _initSelectForm(): void {

        this.fieldCollection.addField({
            type: 'select-search',
            config: {
                id: 'duration',
                attrs: {
                    label: this._translateService.instant('offer.form.fields.duration.value'),
                    required: true,
                    choices: this.offerDurations,
                    multiple: false,
                }
            }
        })
    }

    private _initOfferCreator(): void {

        this._societyService.getItemSelfAPI().subscribe((data: Society): void => {

            this.form.get('offerCreator').patchValue(data.name);
        });
    }

    private _initTransportOfferLocationsControl(): void {

        this.transportOfferLocationsControl = this._formBuilder.group({
            arrival: [null, [() => {

                if(!Boolean(this.selectedAccessTransportTypes.length)){

                    return null;
                }

                if(this.arrivalOfferLocationControl){

                    return null;
                }

                return {
                    'isRequired': {
                        valid: false
                    }
                };
            }]],
            departure: [null, [() => {

                if(!Boolean(this.selectedAccessTransportTypes.length)){

                    return null;
                }

                if(this.form.get('startLocationSameAsEndLocation').value){

                    return null;
                }

                if(this.departureOfferLocationControl){

                    return null;
                }

                return {
                    'isRequired': {
                        valid: false
                    }
                };
            }]]
        })
    }

    private _initLocales(): void {

        this.locales$.next(LOCALE_ITEMS.map((localeItem: LocaleItem): { item: LocaleItem, enabled: boolean } => {

            return {
                item: localeItem,
                enabled: true
            };
        }));
    }

    private _initPublishes(): void {

        this.publishes$ = of(LOCALE_PUBLISHED_ITEMS.filter((item: LocalePublishedItem): boolean => {

            const items: string[] = ['draft'];

            if(this.isPublishable){

                items.push('published');
            }

            if(this.offer.published === 'restricted'){

                items.push('restricted');
            }

            return items.includes(item.name);
        }));
    }

    private _initCurrencies(): void {

        this._currencyService.getItemsAPI().subscribe((currencies: Currency[]): void => {

            this.currencies = currencies.filter((currency: Currency): boolean => {

                return !['TWD','AED'].includes(currency.code);
            });

            if(this.offer.currency){

                this.form.get('currency').patchValue(this.offer.currency.id);
            }
        });
    }

    private _initCustomerTypologies(): void {

        this._customerTypologyService.getItemsAPI().subscribe((items: CustomerTypology[]): void => {

            this.customerTypologies = items;

            const societyTermsAndConditionTypologies: CustomerTypology[] = this.society.termsAndConditions.map((termsAndCondition: TermsAndCondition): CustomerTypology => {

                return termsAndCondition.typology;
            });

            // Filtre des types de clientèles en fonction des documents CGV définis pour la société

            this.customerTypologies = this.customerTypologies.filter((customerTypology: CustomerTypology): boolean => {

                return societyTermsAndConditionTypologies.some((item: CustomerTypology): boolean => {

                    return customerTypology.id === item.id;
                });
            });

            // Configuration Orchestra

            if(!this.isIndividualCustomerTypologyAvailable || (this.offer.customerTypology.type !== 'I')){

                this.configurationControl.get('orchestra').patchValue(false, {onlySelf: true, emitEvent: false});

                this.configurationControl.get('orchestra').disable({onlySelf: true, emitEvent: false});
            }
        });
    }

    private _initTranslations(): void {

        this.translationBuilder = new TranslationBuilder(this._formBuilder);

        this.translationBuilder.form = this.form;

        this.translationBuilder.addItemCallback = (): UntypedFormGroup => {

            return this._formBuilder.group({
                salesPitch: [''],
                name: ['', [Validators.required, Validators.pattern(/^(.{0,60})$/)]],
                teaser: ['', Validators.pattern(/^(.{0,150})$/)],
                description: [''],
                accommodation: [''],
                transportArrivalTrainStationDescription: [null],
                transportArrivalAirportDescription: [null],
                transportDepartureTrainStationDescription: [null],
                transportDepartureAirportDescription: [null],
                pictures: new UntypedFormArray([])
            });
        };
    }

    private _initSeoTranslations(seo: OfferSeo): void {

        this.seoTranslationBuilder.clear();

        seo.translations.forEach((translation: OfferSeoTranslation): void => {

            const group: UntypedFormGroup = this.seoTranslationBuilder.addItemControl(this.seoTranslationBuilder.getLocaleItem(translation.locale), translation);

            group.addControl('id', this._formBuilder.control(translation.id));
        });
    }

    private _setIncluded(): void {

        this.includedControl.clear();

        for (let i = 0; i < this.trueIncludedControl.length; i++) {

            this.includedControl.push(this.trueIncludedControl.controls[i]);
        }

        for (let i = 0; i < this.falseIncludedControl.length; i++) {

            this.includedControl.push(this.falseIncludedControl.controls[i]);
        }
    }

    private _handleFormState(): void {

        this.form.get('offerCreator').disable();

        if(!this.customerTypologyUpdateAllowed){

            this.customerTypologyControl.get('id').disable();
        }
    }

    private _initFormEvents(): void {

        this.form.valueChanges.subscribe(this._updatePanelsValidation.bind(this));

        // Offre Orchestra

        this.configurationControl.get('orchestra').valueChanges.subscribe((orchestra: boolean): void => {

            if(orchestra){

                if(this.customerTypologyUpdateAllowed){

                    // Gestion du type de clientèle

                    this.customerTypologyControl.patchValue(this.customerTypologies.find((item: CustomerTypology): boolean => {

                        return item.type === 'I';
                    }));

                    this.customerTypologyControl.disable();

                    this.handleCustomerTypologyType();
                }

                // Gestion du public

                if(!this.form.get('publics').value.includes('adult')){

                    const publics: OfferPricePublicType[] = this.form.get('publics').value;

                    publics.push('adult');

                    this.form.get('publics').patchValue(publics);
                }

                // Gestion du présentiel

                this._handlePresentialControls(true);

                // Gestion du minimum adulte

                this.presentialControl.get('adultMin').patchValue(1);

                this.presentialControl.get('adultMin').disable();

                // Gestion du pas incrémental adulte

                this.presentialControl.get('adultIncrementalStep').patchValue(1);

                this.presentialControl.get('adultIncrementalStep').disable();

                // Gestion du nombre d'adulte par défaut

                this.presentialControl.get('adultDefault').patchValue(2);

                // Gestion du pas incrémental et du minimum enfant

                if(this.isSelectedOfferPricePublic('child')){

                    this.presentialControl.get('childIncrementalStep').patchValue(1);

                    this.presentialControl.get('childIncrementalStep').disable();

                    this.presentialControl.get('childMin').patchValue(0);

                    this.presentialControl.get('childMin').disable();
                }

                // Gestion de la vente en ligne

                this.form.get('enableOnlineSale').patchValue(true);

                this.form.get('enableOnlineSale').disable();

                // Gestion de l'offre sur devis

                this.form.get('onRequest').patchValue(false, {emitEvent: false, onlySelf: true});

                this.form.get('onRequest').disable({emitEvent: false, onlySelf: true});

                // Gestion de la base du nombre de participants pour le prix à partir de sur devis

                this.form.get('startFromPriceBasedOnParticipantCount').patchValue(null, {emitEvent: false, onlySelf: true});
            }
            else{

                if(this.customerTypologyUpdateAllowed){

                    // Gestion du type de clientèle

                    this.customerTypologyControl.enable();
                }

                // Gestion du pas incrémental adulte

                this.presentialControl.get('adultIncrementalStep').enable();

                this.presentialControl.get('adultMin').enable();

                // Gestion du pas incrémental enfant

                this.presentialControl.get('childIncrementalStep').enable();

                this.presentialControl.get('childMin').enable();

                // Gestion de la vente en ligne

                this.form.get('enableOnlineSale').enable();

                // Gestion de l'offre sur devis

                this.form.get('onRequest').enable({emitEvent: false, onlySelf: true});
            }
        });

        // Sélection des langues

        this.form.get('locales').valueChanges.subscribe((locales: string[]): void => {

            this.form.get('options').patchValue([]);

            this._loadOptions();

            this._handleTranslationControls();

            this._handleSeoTranslationControls();

            this._handleLocationTranslationsControls();

            this.sourceLocales$.next(this.locales$.getValue().map((locale: { item: LocaleItem, enabled: boolean }): { item: LocaleItem, enabled: boolean } => {

                return {
                    item: locale.item,
                    enabled: locales.includes(locale.item.id)
                };
            }));

            this.automaticTranslationSourceLocale = null;

            this.offerService.displayedLocales$.next(locales);

            this.automaticTranslationSourceLocaleUpdated$.next();
        });

        // Offre sur devis

        this.form.get('onRequest').valueChanges.subscribe((): void => {

            this.form.get('startFromPriceBasedOnParticipantCount').patchValue(null);

            this.form.get('displayPrice').patchValue('TTC' as OfferPriceTypeType);

            // Récupération de l'ancienne valeur dans le cas d'une modification
            this.form.get('internalStartFromPriceTTC').patchValue(!this.form.get('onRequest').value && !this.offer.onRequest && this.offer.internalStartFromPriceTTC !== null ? parsePrice(this.offer.internalStartFromPriceTTC / 100, 2, '') : null);

            this._updateCurrencyValidators(true);

            this._patchGiftVoucher();
        });

        // Prix à partir de

        this.form.get('internalStartFromPriceTTC').valueChanges.subscribe((): void => {

            if(!this.form.get('internalStartFromPriceTTC').value || this.form.get('internalStartFromPriceTTC').value === "") {

                this.form.get('startFromPriceBasedOnParticipantCount').patchValue(null);
                this.form.get('startFromPriceBasedOnParticipantCount').disable();

            } else {

                this.form.get('startFromPriceBasedOnParticipantCount').enable();
            }

            this._updateCurrencyValidators(false);
        });

        // Typologie de clientèle

        this.form.get('customerTypology').get('id').valueChanges.subscribe((customerTypologyId: string): void => {

            const customerTypology: CustomerTypology = this.customerTypologies.find((item: CustomerTypology): boolean => {

                return item.id === parseInt(customerTypologyId);
            });

            this.customerTypologyControl.get('type').patchValue(customerTypology ? customerTypology.type : null);

            if(customerTypology){

                const societyTermsAndCondition: TermsAndCondition = this.user.society.termsAndConditions.find((termsAndCondition: TermsAndCondition): boolean => {

                    return termsAndCondition.typology.id === customerTypology.id;
                });

                const societyTermsAndConditionLocales: string[] = societyTermsAndCondition.translations.map((translation: TermsAndConditionTranslation): string => {

                    return translation.locale;
                });

                this.locales$.next(LOCALE_ITEMS.map((localeItem : LocaleItem): { item: LocaleItem, enabled: boolean } => {

                    return {
                        item: localeItem,
                        enabled: societyTermsAndConditionLocales.includes(localeItem.id)
                    };
                }));
            }
            else{

                this.locales$.next(LOCALE_ITEMS.map((localeItem: LocaleItem): { item: LocaleItem, enabled: boolean } => {

                    return {
                        item: localeItem,
                        enabled: true
                    };
                }));
            }

            this.form.get('locales').patchValue([]);

            this.form.get('locales').updateValueAndValidity();

            this.form.get('attributes').updateValueAndValidity();
        });

        // Présentiel max (tout confondus)

        this.presentialControl.get('max').valueChanges.subscribe((): void => {

            this.presentialControl.get('adultMax').updateValueAndValidity();

            this.presentialControl.get('childMax').updateValueAndValidity();
        });

        this.form.get('translationPictureType').valueChanges.subscribe((): void => {

            if(this.isTranslationPictureType('common')){

                const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                    return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
                });

                locales.forEach((locale: string): void => {

                    const translationControl = this.translationBuilder.getItemControlByLocale(locale);

                    const destinationPicturesControl: UntypedFormArray = translationControl.get('pictures') as UntypedFormArray;

                    const sourcePicturesControl: UntypedFormArray = this.translationBuilder.itemsControl.at(0).get('pictures') as UntypedFormArray;

                    destinationPicturesControl.clear();

                    sourcePicturesControl.controls.forEach((control: UntypedFormGroup, index: number): void => {

                        this.addTranslationPicture(translationControl.get('pictures'));

                        const sourcePictureControl: UntypedFormGroup = sourcePicturesControl.at(index) as UntypedFormGroup;

                        const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                        if(destinationPictureControl){

                            destinationPictureControl.get('copyright').patchValue(sourcePictureControl.get('copyright').value);

                            if(sourcePictureControl.get('image').get('image').value){

                                this._imageService.getCloneImage(sourcePictureControl.get('image').get('image').value).subscribe((cloneImage: Image): void => {

                                    destinationPictureControl.get('image').get('image').patchValue(cloneImage);

                                    const destinationImage: Image = Object.assign(destinationPictureControl.get('image').get('image').value, {
                                        formats: sourcePictureControl.get('image').get('image').value.formats
                                    });

                                    this._imageService.crop(destinationImage).subscribe((): void => {

                                        destinationPictureControl.updateValueAndValidity();
                                    });
                                });
                            }
                        }
                    });
                });
            }

            this.handleContentManagementValidators();

            this.offerFormTabValidationService.refreshItems(this.formTabValidationItemsCallback());
        });

        // Nombre maximum de localisations secondaires

        this.form.get('limitLocation').valueChanges.subscribe((): void => {

            if (!this.form.get('enableMultipleMainLocation').value) {

                this._resetLocationsControlValidation();
            }
        });

        // Type de localisation

        this.form.get('enableMultipleMainLocation').valueChanges.subscribe((enableMultipleMainLocation: boolean) : void => {

            // Suppression de la bride de 3 localisations par jour dans le cas de "plusieurs adresses principales"

            this._resetLocationsControlValidation();

            if(enableMultipleMainLocation){

                this.form.get('circuitType').patchValue('itinerant' as OfferCircuitType);
            }

            // Réinitialisation des données transports

            this.resetTransportConfiguration(true);

            // Gestion de l'onglet "Accès"

            if(enableMultipleMainLocation){

                const accessTabIndex: number = this.tabItems.findIndex((item): boolean => {

                    return item.tag === 'access';
                });

                this.tabItems.splice(accessTabIndex, 1);
            }
            else{

                const hasAccessTab: boolean = this.tabItems.some((item): boolean => {

                    return item.tag === 'access';
                });

                if(!hasAccessTab){

                    const locationTabIndex: number = this.tabItems.findIndex((item): boolean => {

                        return item.tag === 'locationData';
                    });

                    this.tabItems.splice(locationTabIndex + 1, 0, {
                        tag: 'access',
                        label: 'offer.access.value',
                        template: this.accessRef
                    });
                }
            }
        });

        this.providerSocietiesControl.valueChanges.subscribe((items: Society[]) => {

            this.offerService.providersSocieties$.next(items);
        });

        this.offerService.providerLocationsUpdate$.subscribe((data): void => {

            this.locationsControl.controls.forEach((control) => {

                const controlProviders: Society[] = [...control.get('providers').value];

                const isAppliedToLocation: boolean = controlProviders.some((controlProvider: Society): boolean => {

                    return controlProvider.id === data.provider.id;
                });

                if(data.selected && !isAppliedToLocation){

                    controlProviders.push(data.provider);
                }

                if(!data.selected && isAppliedToLocation){

                    const index: number = controlProviders.findIndex((controlProvider: Society): boolean => {

                        return controlProvider.id === data.provider.id;
                    });

                    controlProviders.splice(index, 1);
                }

                (control.get('providers') as UntypedFormControl).patchValue(controlProviders);
            });
        });

        this.form.get('locations').valueChanges.pipe(skip(1)).subscribe((items: OfferLocation[]) : void => {

            if(this.form.get('enableMultipleMainLocation').value) {

                this._updateLocationsProviders(items);
            }

            Object.values(this.transportOfferLocationsControl.controls).forEach((control: FormControl) => control.updateValueAndValidity({ onlySelf: true, emitEvent: false }));

            setTimeout((): void => {

                this.handleTransportDescriptionControls();

                this.resetTransportCalculations();
            });
        });

        const transportUpdatedLocationControls: AbstractControl[] = (this.locationsControl.controls as FormGroup[]).reduce((accumulator: AbstractControl[], currentValue: FormGroup): AbstractControl[] => {

            accumulator.push(...this.getTransportUpdatedLocationControlsFromLocationControl(currentValue));

            return accumulator;

        }, []);

        transportUpdatedLocationControls.forEach((transportUpdatedLocationControl: AbstractControl): void => {

            transportUpdatedLocationControl.valueChanges.subscribe((): void => {

                this.resetTransportOfferLocationControlsByLocationControl(transportUpdatedLocationControl.parent as FormGroup);
            });
        });

        this.form.get('displayTransportDuration').valueChanges.subscribe((): void => {

            this.resetTransportCalculations();
        });

        this.form.get('isRestricted').valueChanges.subscribe((): void => {

            this.restrictedSocietiesControl.patchValue([]);
        });

        this.form.get('hasProgramsPictures').valueChanges.subscribe((): void => {

            setTimeout((): void => {

                this.handleContentManagementValidators();
            });
        });

        this.enableAutomaticTranslationUpdated$.subscribe((): void => {

            this.automaticTranslationSourceLocale = null;

            this.offerService.displayedLocales$.next(this.form.get('locales').value);

            this.automaticTranslationSourceLocaleUpdated$.next();
        });

        this.automaticTranslationSourceLocaleUpdated$.subscribe((): void => {

            const locales: string[] = this.form.get('locales').value;

            this.destinationLocales$.next(this.locales$.getValue().map((locale: { item: LocaleItem, enabled: boolean }): { item: LocaleItem, enabled: boolean } => {

                return {
                    item: locale.item,
                    enabled: locales.includes(locale.item.id) && (this.automaticTranslationSourceLocale !== locale.item.id)
                };
            }))

            this.automaticTranslationDestinationLocales = [];

            this.automaticTranslationDestinationLocalesUpdated$.next();

            this.handleContentManagementValidators();
        });

        this.automaticTranslationDestinationLocalesUpdated$.subscribe((): void => {

            if(!this.enableAutomaticTranslation || !this.automaticTranslationDestinationLocales.length){

                this.translationRequestSummary$.next({
                    totalPriceTTC: 0
                });

                return;
            }

            if(this.automaticTranslationSourceLocale){

                const data: { sourceLocale: string, targetLocales: string[] } = {
                    sourceLocale: this.automaticTranslationSourceLocale,
                    targetLocales: this.automaticTranslationDestinationLocales
                };

                this._offerTranslationService.requestSummaryAPI(data).subscribe((item: OfferTranslationRequest): void => {

                    this.translationRequestSummary$.next(item);

                    setTimeout((): void => {

                        this.scrollToBottomOfElement(this.translationRequestSummaryReference);
                    });
                });
            }
            else {

                this.translationRequestSummary$.next({
                    totalPriceTTC: 0
                });
            }
        });

        this.translationRequestSummary$.subscribe((): void => {

            this.form.get('optinAutomaticTranslation').patchValue(false);

            this.form.get('optinAutomaticTranslation').updateValueAndValidity();
        });

        this._imageEventService.imageCropped.subscribe((image: Image): void => {

            if(this.isTranslationPictureType('dissociated')){

                return;
            }

            const index: number = (this.translationsControl.at(0).get('pictures').value as OfferTranslationPicture[]).findIndex((item: OfferTranslationPicture): boolean => {

                if(!item.image || !item.image.image){

                    return false;
                }

                return (item.image.image as unknown as Image).id === image.id;
            });

            if(index < 0){

                return;
            }

            const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
            });

            locales.forEach((locale: string): void => {

                const destinationPicturesControl: UntypedFormArray = (this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray);

                const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                if(destinationPictureControl){

                    const destinationImage: Image = Object.assign(destinationPictureControl.get('image').get('image').value, {
                        formats: image.formats
                    });

                    this._imageService.crop(destinationImage).subscribe((): void => {

                        this._changeDetectorRef.detectChanges();
                    });
                }
            });
        });
    }

    private _handleExistingOfferTranslationContents(): void {

        const items: string[] = this.offer.locales.filter((locale: string): boolean => {

            return this.automaticTranslationDestinationLocales.includes(locale);

        });

        items.forEach((locale: string): void => {

            const translationControl: UntypedFormGroup = this.translationsControl.controls.find((control: UntypedFormGroup): boolean => {

                return control.get('locale').value === locale;

            }) as UntypedFormGroup;

            translationControl.patchValue({
                ...this.offer.translations.find((translationItem: TranslationItem): boolean => {

                    return translationItem.locale === locale;

                })
            });

            this.interestsControl.controls.forEach((interestControl: UntypedFormGroup, index: number): void => {

                const translationControl: UntypedFormGroup = (interestControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                    return control.get('locale').value === locale;

                }) as UntypedFormGroup;

                if(this.offer.interests[index]) {

                    translationControl.patchValue({
                        ...this.offer.interests[index].translations.find((translationItem: TranslationItem): boolean => {

                            return translationItem.locale === locale;
                        })
                    });
                }
            });

            const trueIncludedItems: OfferIncluded[] = this.offer.included.filter((item: OfferIncluded): boolean => {

                return item.isIncluded;
            });

            this.trueIncludedControl.controls.forEach((trueIncludeControl: UntypedFormGroup, index: number): void => {

                const translationControl: UntypedFormGroup = (trueIncludeControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                    return control.get('locale').value === locale;

                }) as UntypedFormGroup;

                if(trueIncludedItems[index]) {

                    translationControl.patchValue({
                        ...trueIncludedItems[index].translations.find((translationItem: TranslationItem): boolean => {

                            return translationItem.locale === locale;
                        })
                    });
                }
            });

            const falseIncludedItems: OfferIncluded[] = this.offer.included.filter((item: OfferIncluded): boolean => {

                return !item.isIncluded;
            });

            this.falseIncludedControl.controls.forEach((falseIncludeControl: UntypedFormGroup, index: number): void => {

                const translationControl: UntypedFormGroup = (falseIncludeControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                    return control.get('locale').value === locale;

                }) as UntypedFormGroup;

                if(falseIncludedItems[index]) {

                    translationControl.patchValue({
                        ...falseIncludedItems[index].translations.find((translationItem: TranslationItem): boolean => {

                            return translationItem.locale === locale;
                        })
                    });
                }
            });

            this.programsControl.controls.forEach((programControl: UntypedFormGroup, index: number): void => {

                const translationControl: UntypedFormGroup = (programControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                    return control.get('locale').value === locale;

                }) as UntypedFormGroup;

                if(this.offer.programs[index]) {

                    translationControl.patchValue({
                        ...this.offer.programs[index].translations.find((translationItem: TranslationItem): boolean => {

                            return translationItem.locale === locale;
                        })
                    });
                }
            });

            this.locationsControl.controls.forEach((locationControl: UntypedFormGroup, index: number): void => {

                const translationControl: UntypedFormGroup = (locationControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                    return control.get('locale').value === locale;

                }) as UntypedFormGroup;

                if(this.offer.locations[index]) {

                    translationControl.patchValue({
                        ...this.offer.locations[index].translations.find((translationItem: TranslationItem): boolean => {

                            return translationItem.locale === locale;
                        })
                    });
                }
            });

            const translationSeoControl: UntypedFormGroup = (this.seoControl.get('translations') as UntypedFormArray).controls.find((control: UntypedFormGroup): boolean => {

                return control.get('locale').value === locale;

            }) as UntypedFormGroup;

            translationSeoControl.patchValue({
                ...this.offer.seo.translations.find((translationItem: TranslationItem): boolean => {

                    return translationItem.locale === locale;

                })
            });
        });
    }

    private _resetLocationsControlValidation(): void {

        if (this.form.get('enableMultipleMainLocation').value) {

            this.locationsControl.setValidators([]);
        }
        else {

            this.locationsControl.setValidators([Validators.maxLength((this.form.get('limitLocation').value as number) + 1)]);
        }

        this.locationsControl.updateValueAndValidity();
    }

    private _updateLocationsProviders(offerLocations: OfferLocation[]): void {

        const providers: Society[][] = offerLocations.map((item: OfferLocation): Society[] => {

            return item.providers
        });

        if (!providers.length) {

            return;
        }

        const intersection = [...providers].reduce((a: Society[], b: Society[]) => {

            return a.filter((c: Society): boolean => {

                return b.some((d: Society): boolean => {

                    return d.id === c.id;
                });
            })
        });

        const locationsProviders = [...new Set(intersection)];

        this.providerLocations.patchValue(locationsProviders, { emitEvent: false });
    }

    private _updateMultipleMainLocationControl() {

        if (!this.geolocationIsAllowed) {

            this.form.get('enableMultipleMainLocation').patchValue(false);
        }

        this.form.get('enableMultipleMainLocation').updateValueAndValidity();
    }

    private _updateValidatorsGiftVoucher() {

        if(!this.hasAccessGiftVoucher)
            return;

        const control: UntypedFormGroup = this.form.get('giftVoucher') as UntypedFormGroup;

        const childControlsToUpdate: AbstractControl[] = [
            control.get('types'),
            control.get('childPriceTTC'),
            control.get('adultPriceTTC'),
        ];

        childControlsToUpdate.forEach((childControl: AbstractControl): void => {

            childControl.clearValidators();
        });

        if(this.form.get('enableGiftVoucher').value){

            // Validateurs

            control.get('types').setValidators([Validators.required]);

            if (this.form.get('publics').value.includes('adult')) {

                control.get('adultPriceTTC').patchValue(null);

                control.get('adultPriceTTC').setValidators([Validators.required, Validators.pattern(REGEX_PRICE)]);

            } else {

                control.get('adultPriceTTC').patchValue(0);

                control.get('adultPriceTTC').setValidators([]);
            }

            if (this.form.get('publics').value.includes('child')) {

                // Valeurs

                control.get('childPriceTTC').patchValue(null);

                control.get('childPriceTTC').setValidators([Validators.required, Validators.pattern(REGEX_PRICE)]);

            } else {

                control.get('childPriceTTC').patchValue(0);

                control.get('childPriceTTC').setValidators([]);
            }

        }
        else {

            control.get('types').patchValue([]);

            control.get('adultPriceTTC').patchValue(0);

            control.get('childPriceTTC').patchValue(0);

            control.get('types').setValidators([]);

            control.get('adultPriceTTC').setValidators([]);

            control.get('childPriceTTC').setValidators([]);

        }

        childControlsToUpdate.forEach((childControl: AbstractControl): void => {

            childControl.updateValueAndValidity();
        });

    }

    private _handleTranslationControls(): void {

        const locales: string[] = this.form.get('locales').value;

        if(!this.translationBuilder){

            return;
        }

        this.translationBuilder.updateItems(locales);

        setTimeout((): void => {

            if(this.isTranslationPictureType('common')){

                this.offerService.displayedLocales$.getValue().forEach((locale: string): void => {

                    const translationControl = this.translationBuilder.getItemControlByLocale(locale);

                    const destinationPicturesControl: UntypedFormArray = translationControl.get('pictures') as UntypedFormArray;

                    if(destinationPicturesControl.controls.length){

                        return;
                    }

                    const sourcePicturesControl: UntypedFormArray = this.translationBuilder.itemsControl.at(0).get('pictures') as UntypedFormArray;

                    sourcePicturesControl.controls.forEach((control: UntypedFormGroup, index: number): void => {

                        this.addTranslationPicture(translationControl.get('pictures'));

                        const sourcePictureControl: UntypedFormGroup = sourcePicturesControl.at(index) as UntypedFormGroup;

                        const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                        if(destinationPictureControl){

                            destinationPictureControl.get('copyright').patchValue(sourcePictureControl.get('copyright').value);

                            this._imageService.getCloneImage(sourcePictureControl.get('image').get('image').value).subscribe((cloneImage: Image): void => {

                                destinationPictureControl.get('image').get('image').patchValue(cloneImage);

                                const destinationImage: Image = Object.assign(destinationPictureControl.get('image').get('image').value, {
                                    formats: sourcePictureControl.get('image').get('image').value.formats
                                });

                                this._imageService.crop(destinationImage).subscribe((): void => {});
                            });
                        }
                    });
                });
            }

            this.handleContentManagementValidators();

            this.offerFormTabValidationService.refreshItems(this.formTabValidationItemsCallback());
        });
    }

    private _handleSeoTranslationControls(): void {

        const locales: string[] = this.form.get('locales').value;

        this.seoTranslationBuilder.updateItems(locales);
    }

    private _handleLocationTranslationsControls(): void {

        const locales: string[] = this.form.get('locales').value;

        this.locationTranslationBuilders.forEach((builder: TranslationBuilder): void => {

            builder.updateItems(locales);
        });
    }

    private _updateCurrencyValidators(reset: boolean): void {

        if(reset) {

            this.form.get('currency').patchValue(null);
        }

        this.form.get('currency').clearValidators();

        const validators: ValidatorFn[] = [];

        if(!this.form.get('onRequest').value || this.form.get('internalStartFromPriceTTC').value){

            validators.push(Validators.required);

            this.form.get('currency').enable();

        } else {

            this.form.get('currency').disable();
            this.form.get('currency').patchValue(null);
        }

        this.form.get('currency').setValidators(validators);

        this.form.get('currency').updateValueAndValidity();
    }

    private _patchGiftVoucher() {

        if(this.form.get('onRequest').value){

            this.form.get('enableGiftVoucher').patchValue(false);

            this.form.get('enableOnlineSale').patchValue(false);
        }
    }

    private _cleanRestrictedSocieties(offer: Offer): void {

        const items: Society[] = [...offer.restrictedSocieties];

        // On supprime le créateur d'offre

        const currentSocietyItemIndex: number = items.findIndex((item: Society): boolean => {

            return item.id === this.society.id;
        });

        if(currentSocietyItemIndex >= 0){

            items.splice(currentSocietyItemIndex, 1);
        }

        // On supprime les prestataires sélectionnés

        offer.providerSocieties.forEach((providerSociety: Society): void => {

            const providerSocietyItemIndex: number = items.findIndex((item: Society): boolean => {

                return item.id === providerSociety.id;
            });

            if(providerSocietyItemIndex >= 0){

                items.splice(providerSocietyItemIndex, 1);
            }
        });

        Object.assign(offer, {
            restrictedSocieties: items
        });

        this.offer.restrictedSocieties = items;
    }

    private _offerHasPictures(): boolean {

        const test = this.offer.programs.some((program: OfferProgram) => {

            return program.translations.some((translation: OfferProgramTranslation) => {

                return translation.picture != null;
            });

        });

        return test;
    }

    private _handlePresentialControls(resetValues: boolean): void{

        const control: UntypedFormGroup = this.presentialControl;

        const childControlsToUpdate: AbstractControl[] = [
            control.get('adultMin'),
            control.get('adultMax'),
            control.get('adultIncrementalStep'),
            control.get('adultDefault'),
            control.get('childMin'),
            control.get('childMax'),
            control.get('childIncrementalStep'),
            control.get('childDefault')
        ];

        childControlsToUpdate.forEach((childControl: AbstractControl): void => {

            childControl.clearValidators();
        });

        if(this.form.get('publics').value.includes('adult')){

            // Validateurs

            control.get('adultMin').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/)]);

            control.get('adultMax').setValidators([Validators.required, Validators.pattern(/^[1-9][0-9]*$/), (adultMaxControl: UntypedFormControl) => {

                if(!adultMaxControl.value){

                    return null;
                }

                if(!control.get('max') || !control.get('max').value){

                    return null;
                }

                if(parseInt(adultMaxControl.value) <= parseInt(control.get('max').value)){

                    return null;
                }

                return {
                    'isTooHigh': {
                        valid: false
                    }
                };
            }]);

            control.get('adultIncrementalStep').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/), Validators.min(1), offerPresentialAdultIncrementalStepValidator]);

            control.get('adultDefault').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/), offerPresentialAdultDefaultValidator]);

        }
        else{

            if(resetValues){

                // Valeurs

                control.get('adultMin').patchValue(0);

                control.get('adultMax').patchValue(0);

                control.get('adultIncrementalStep').patchValue(0);

                control.get('adultDefault').patchValue(0);
            }

            // Validateurs

            control.get('adultMin').setValidators([]);

            control.get('adultMax').setValidators([]);

            control.get('adultIncrementalStep').setValidators([]);

            control.get('adultDefault').setValidators([]);
        }

        if(this.form.get('publics').value.includes('child')){

            // Validateurs

            control.get('childMin').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/)]);

            control.get('childMax').setValidators([Validators.required, Validators.pattern(/^[1-9][0-9]*$/), (childMaxControl: UntypedFormControl) => {

                if(!childMaxControl.value){

                    return null;
                }

                if(!control.get('max') || !control.get('max').value){

                    return null;
                }

                if(parseInt(childMaxControl.value) <= parseInt(control.get('max').value)){

                    return null;
                }

                return {
                    'isTooHigh': {
                        valid: false
                    }
                };
            }]);

            control.get('childIncrementalStep').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/), Validators.min(1), offerPresentialChildIncrementalStepValidator]);

            control.get('childDefault').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/), offerPresentialChildDefaultValidator]);

            if(this.isOrchestra) {

                control.get('childMin').patchValue(0);
                control.get('childMin').disable({emitEvent: false, onlySelf: true});

                control.get('childIncrementalStep').patchValue(1);
                control.get('childIncrementalStep').disable({emitEvent: false, onlySelf: true});
            }
        }
        else{

            if(resetValues){

                // Valeurs

                control.get('childMin').patchValue(0);

                control.get('childMax').patchValue(0);

                control.get('childIncrementalStep').patchValue(0);

                control.get('childDefault').patchValue(0);
            }

            // Validateurs

            control.get('childMin').setValidators([]);

            control.get('childMax').setValidators([]);

            control.get('childIncrementalStep').setValidators([]);

            control.get('childDefault').setValidators([]);
        }

        childControlsToUpdate.forEach((childControl: AbstractControl): void => {

            childControl.updateValueAndValidity();
        });
    }

    public handleContentManagementValidators(): void {

        this.translationBuilder.itemsControl.controls.forEach((control: UntypedFormGroup): void => {

            const locale: string = control.get('locale').value;

            // Nom

            control.get('name').clearValidators();

            const nameValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                nameValidators.push(Validators.required, Validators.pattern(/^(.{0,60})$/));
            }

            control.get('name').setValidators(nameValidators);

            control.get('name').updateValueAndValidity();

            // Description

            control.get('description').clearValidators();

            const descriptionValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                descriptionValidators.push((control: AbstractControl): { [key: string]: any } => {

                    if (!control.value) {

                        return null;
                    }

                    if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 7000) {

                        return null;
                    }

                    return {
                        'textMaxLength': {
                            valid: false
                        }
                    };
                });
            }

            control.get('description').setValidators(descriptionValidators);

            control.get('description').updateValueAndValidity();

            // Description sur l'arrivée en train pour le transport

            control.get('transportArrivalTrainStationDescription').clearValidators();

            const transportArrivalTrainStationDescription: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                transportArrivalTrainStationDescription.push((control: AbstractControl): { [key: string]: any } => {

                    if (!control.value) {

                        return null;
                    }

                    if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 1000) {

                        return null;
                    }

                    return {
                        'maxLength': {
                            valid: false
                        }
                    };
                });
            }

            control.get('transportArrivalTrainStationDescription').setValidators(transportArrivalTrainStationDescription);

            control.get('transportArrivalTrainStationDescription').updateValueAndValidity();

            // Description sur l'arrivée en avion pour le transport

            control.get('transportArrivalAirportDescription').clearValidators();

            const transportArrivalAirportDescription: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                transportArrivalAirportDescription.push((control: AbstractControl): { [key: string]: any } => {

                    if (!control.value) {

                        return null;
                    }

                    if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 1000) {

                        return null;
                    }

                    return {
                        'maxLength': {
                            valid: false
                        }
                    };
                });
            }

            control.get('transportArrivalAirportDescription').setValidators(transportArrivalAirportDescription);

            control.get('transportArrivalAirportDescription').updateValueAndValidity();

            // Description sur le départ en train pour le transport

            control.get('transportDepartureTrainStationDescription').clearValidators();

            const transportDepartureTrainStationDescription: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                transportDepartureTrainStationDescription.push((control: AbstractControl): { [key: string]: any } => {

                    if (!control.value) {

                        return null;
                    }

                    if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 1000) {

                        return null;
                    }

                    return {
                        'maxLength': {
                            valid: false
                        }
                    };
                });
            }

            control.get('transportDepartureTrainStationDescription').setValidators(transportDepartureTrainStationDescription);

            control.get('transportDepartureTrainStationDescription').updateValueAndValidity();

            // Description sur le départ en avion pour le transport

            control.get('transportDepartureAirportDescription').clearValidators();

            const transportDepartureAirportDescription: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                transportDepartureAirportDescription.push((control: AbstractControl): { [key: string]: any } => {

                    if (!control.value) {

                        return null;
                    }

                    if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 1000) {

                        return null;
                    }

                    return {
                        'maxLength': {
                            valid: false
                        }
                    };
                });
            }

            control.get('transportDepartureAirportDescription').setValidators(transportDepartureAirportDescription);

            control.get('transportDepartureAirportDescription').updateValueAndValidity();

            // Teaser

            control.get('teaser').clearValidators();

            const teaserValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(locale)){

                teaserValidators.push(Validators.pattern(/^(.{0,150})$/));
            }

            control.get('teaser').setValidators(teaserValidators);

            control.get('teaser').updateValueAndValidity();

            // Visuels

            const picturesControl: UntypedFormArray = control.get('pictures') as UntypedFormArray;

            picturesControl.controls.forEach((pictureControl: UntypedFormGroup): void => {

                // Image

                pictureControl.get('image').get('image').clearValidators();

                const imageValidator: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(locale)){

                    imageValidator.push(Validators.required);
                }

                pictureControl.get('image').get('image').setValidators(imageValidator);

                pictureControl.get('image').get('image').updateValueAndValidity();

                // Copyright

                pictureControl.get('copyright').clearValidators();

                const copyrightValidator: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(locale)){

                    copyrightValidator.push(Validators.required);
                }

                pictureControl.get('copyright').setValidators(copyrightValidator);

                pictureControl.get('copyright').updateValueAndValidity();
            });
        });

        // Intérêts

        const interestsControl: UntypedFormArray = this.form.get('interests') as UntypedFormArray;

        interestsControl.controls.forEach((interestControl): void => {

            const translationsControl: UntypedFormArray = interestControl.get('translations') as UntypedFormArray;

            translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                // Label

                translationControl.get('label').clearValidators();

                const translationLabelValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationLabelValidators.push(Validators.required, Validators.pattern(/^(.{0,100})$/));
                }

                translationControl.get('label').setValidators(translationLabelValidators);

                translationControl.get('label').updateValueAndValidity();
            });
        });

        // Inclus dans l'offre

        this.trueIncludedControl.controls.forEach((trueIncludedControl: UntypedFormArray): void => {

            const translationsControl: UntypedFormArray = trueIncludedControl.get('translations') as UntypedFormArray;

            translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                // Titre

                translationControl.get('title').clearValidators();

                const translationTitleValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationTitleValidators.push(Validators.required, Validators.maxLength(255));
                }

                translationControl.get('title').setValidators(translationTitleValidators);

                translationControl.get('title').updateValueAndValidity();

                // Description

                translationControl.get('description').clearValidators();

                const translationDescriptionValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationDescriptionValidators.push(Validators.maxLength(255));
                }

                translationControl.get('description').setValidators(translationDescriptionValidators);

                translationControl.get('description').updateValueAndValidity();
            });
        });

        // Non inclus dans l'offre

        this.falseIncludedControl.controls.forEach((trueIncludedControl: UntypedFormArray): void => {

            const translationsControl: UntypedFormArray = trueIncludedControl.get('translations') as UntypedFormArray;

            translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                // Titre

                translationControl.get('title').clearValidators();

                const translationTitleValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationTitleValidators.push(Validators.required, Validators.maxLength(255));
                }

                translationControl.get('title').setValidators(translationTitleValidators);

                translationControl.get('title').updateValueAndValidity();

                // Description

                translationControl.get('description').clearValidators();

                const translationDescriptionValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationDescriptionValidators.push(Validators.maxLength(255));
                }

                translationControl.get('description').setValidators(translationDescriptionValidators);

                translationControl.get('description').updateValueAndValidity();
            });
        });

        // Programme

        this.programsControl.controls.forEach((programControl: UntypedFormGroup): void => {

            const translationsControl: UntypedFormArray = programControl.get('translations') as UntypedFormArray;

            translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                // Titre

                translationControl.get('title').clearValidators();

                const translationTitleValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationTitleValidators.push(Validators.required);
                }

                translationControl.get('title').setValidators(translationTitleValidators);

                translationControl.get('title').updateValueAndValidity();

                // Description

                translationControl.get('description').clearValidators();

                const translationDescriptionValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationDescriptionValidators.push(Validators.required, (control: AbstractControl): { [key: string]: any } => {

                        if (!control.value) {

                            return null;
                        }

                        if ((control.value.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ')).length <= 800) {

                            return null;
                        }

                        return {
                            'textMaxLength': {
                                valid: false
                            }
                        };
                    });
                }

                translationControl.get('description').setValidators(translationDescriptionValidators);

                translationControl.get('description').updateValueAndValidity();

                const pictureControl: UntypedFormGroup = translationControl.get('picture') as UntypedFormGroup;

                if(pictureControl){

                    if(pictureControl.get('image')){

                        // Image

                        pictureControl.get('image').get('image').clearValidators();

                        const imageValidator: ValidatorFn[] = [];

                        if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                            imageValidator.push(Validators.required);
                        }

                        pictureControl.get('image').get('image').setValidators(imageValidator);

                        pictureControl.get('image').get('image').updateValueAndValidity();

                    }

                    if(pictureControl.get('copyright')){

                        // Copyright

                        pictureControl.get('copyright').clearValidators();

                        const copyrightValidator: ValidatorFn[] = [];

                        if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                            copyrightValidator.push(Validators.required);
                        }

                        pictureControl.get('copyright').setValidators(copyrightValidator);

                        pictureControl.get('copyright').updateValueAndValidity();
                    }
                }
            });
        });

        // Localisation

        this.locationsControl.controls.forEach((locationControl: UntypedFormArray): void => {

            const translationsControl: UntypedFormArray = locationControl.get('translations') as UntypedFormArray;

            translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                // Description

                translationControl.get('description').clearValidators();

                const translationDescriptionValidators: ValidatorFn[] = [];

                if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                    translationDescriptionValidators.push(Validators.pattern(/^(.{0,200})$/));
                }

                translationControl.get('description').setValidators(translationDescriptionValidators);

                translationControl.get('description').updateValueAndValidity();
            });
        });

        // SEO

        (this.seoControl.get('translations') as UntypedFormArray).controls.forEach((translationControl: UntypedFormGroup): void => {

            // Slug

            translationControl.get('slug').clearValidators();

            const translationSlugValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                translationSlugValidators.push(Validators.required);
                translationSlugValidators.push(Validators.pattern(REGEX_SLUG));
            }

            translationControl.get('slug').setValidators(translationSlugValidators);

            translationControl.get('slug').updateValueAndValidity();

            // Meta Title

            translationControl.get('metaTitle').clearValidators();

            const translationTitleValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                translationTitleValidators.push(Validators.required);
            }

            translationControl.get('metaTitle').setValidators(translationTitleValidators);

            translationControl.get('metaTitle').updateValueAndValidity();

            // Meta Description

            translationControl.get('metaDescription').clearValidators();

            const translationDescriptionValidators: ValidatorFn[] = [];

            if(!this.automaticTranslationDestinationLocales.includes(translationControl.get('locale').value)){

                translationDescriptionValidators.push(Validators.required);

                translationDescriptionValidators.push(Validators.maxLength(255));
            }

            translationControl.get('metaDescription').setValidators(translationDescriptionValidators);

            translationControl.get('metaDescription').updateValueAndValidity();
        });
    }

    public changeDuration(event: any): void {

        this.groupDurationControl.get('id').patchValue(event.value);

        const idFilter: TextFilterField = new TextFilterField('id', 'eq', event.value);

        const params: string[] = [
            idFilter.serialize
        ];

        this._offerDurationService.getItemsAPI(params).subscribe((data: OfferDuration[]): void => {

            this.limitProgram = data[0].limitProgram;
            this.limitLocation = data[0].limitLocation;

            this.form.get('limitLocation').setValue(this.limitLocation);

            this._updateMultipleMainLocationControl();
        });

    }

    public handleOfferPricePublic(event: any): void {

        const control: UntypedFormControl = this.form.get('publics') as UntypedFormControl;

        const controlValue: OfferPricePublicType[] = control.value;

        const value: OfferPricePublicType = event.target.value;

        if(event.target.checked){

            controlValue.push(value);
        }
        else{

            const index: number = controlValue.findIndex((i: OfferPricePublicType): boolean => {

                return i === value;
            });

            controlValue.splice(index, 1);
        }

        control.patchValue(controlValue);

        this._handlePresentialControls(true);

        if(this.isOrchestra && this.isSelectedOfferPricePublic('child')){

            this.presentialControl.get('childIncrementalStep').patchValue(1);
        }

        this._updateValidatorsGiftVoucher();
    }

    public handleLocaleSelection(event: any): void {

        const control: UntypedFormControl = this.form.get('locales') as UntypedFormControl;

        const controlValue: string[] = control.value;

        const value: string = event.target.value;

        if (event.target.checked) {

            controlValue.push(value);

        } else {

            const index: number = controlValue.findIndex((item: string): boolean => {

                return item === value;
            });

            controlValue.splice(index, 1);
        }

        control.patchValue(controlValue);

        control.updateValueAndValidity();

        setTimeout((): void => {

            if(this.hasAccessAutomaticTranslation && this.form.get('locales').valid){

                this.scrollToBottomOfElement(this.enableAutomaticTranslation ? this.sourceLocaleDescriptionReference : this.enableAutomaticTranslationReference);
            }
        });
    }

    public handleEnableAutomaticTranslation(): void {

        this.enableAutomaticTranslationUpdated$.next();

        setTimeout((): void => {

            if(this.enableAutomaticTranslation){

                this.scrollToBottomOfElement(this.sourceLocaleDescriptionReference);
            }
        });
    }

    public handleSourceLocaleSelection(event: any): void {

        this.automaticTranslationSourceLocale = event.target.value;

        this.automaticTranslationSourceLocaleUpdated$.next();

        setTimeout((): void => {

            if(!!this.automaticTranslationSourceLocale){

                this.scrollToBottomOfElement(this.destinationLocalesDescriptionReference);
            }
        });
    }

    public handleDestinationLocaleSelection(event: any): void {

        // Mise à jour des langues à traduire automatiquement

        const value: string = event.target.value;

        if (event.target.checked) {

            this.automaticTranslationDestinationLocales.push(value);

        } else {

            const index: number = this.automaticTranslationDestinationLocales.findIndex((item: string): boolean => {

                return item === value;
            });

            this.automaticTranslationDestinationLocales.splice(index, 1);
        }

        this.automaticTranslationDestinationLocalesUpdated$.next();

        // Mise à jour des langues affichées à traduire manuellement

        const locales: string[] = this.form.get('locales').value;

        this.offerService.displayedLocales$.next(locales.filter((locale: string): boolean => {

            return !this.automaticTranslationDestinationLocales.includes(locale);
        }));

        this._handleExistingOfferTranslationContents();

        // Mise à jour de la validation des champs

        this.handleContentManagementValidators();

        // Raffraîchissement de la validation des onglets

        this.offerFormTabValidationService.refreshItems(this.formTabValidationItemsCallback());
    }

    public handleEnableGiftVoucher(): void {

        this._updateValidatorsGiftVoucher();
    }

    public isSelectedOfferPricePublic(type: OfferPricePublicType): boolean {

        return this.form.get('publics').value.includes(type);
    }

    public createCustomerTypologyGroup(data: CustomerTypology): UntypedFormGroup {

        return this._formBuilder.group({
            id: [data.id, Validators.required],
            type: [data.type, Validators.required]
        });
    }

    public createDurationGroup(data: OfferDuration): UntypedFormGroup {

        return this._formBuilder.group({
            id: [data.id, Validators.required],
        });
    }

    public createSeoGroup(data: OfferSeo): UntypedFormGroup {

        const control: UntypedFormGroup = this._formBuilder.group({
            follow: [data.follow, Validators.required],
            translations: new UntypedFormArray([])
        });

        if('id' in data){

            control.addControl('id', new UntypedFormControl(data.id, [Validators.required]));
        }

        this.seoTranslationBuilder  = new TranslationBuilder(this._formBuilder);

        this.seoTranslationBuilder.form = control;

        this.seoTranslationBuilder.addItemCallback = (): UntypedFormGroup => {

            return this._formBuilder.group({
                slug: ['', [Validators.required, Validators.pattern(REGEX_SLUG)]],
                metaTitle: ['', [Validators.required]],
                metaDescription: ['', [Validators.required, Validators.maxLength(255)]]
            });
        };

        return control;
    }

    get createGiftVoucherGroup() {

        return this._formBuilder.group({
            adultPriceTTC: [0, [Validators.pattern(REGEX_PRICE)]],
            childPriceTTC: [0, [Validators.pattern(REGEX_PRICE)]],
            types: [[]]
        });
    }

    public createPresentialGroup(data: OfferPresential, enableMax: boolean): UntypedFormGroup {

        return this._formBuilder.group({
            id: [data.id, [Validators.required]],
            max: [data.max, enableMax ? [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.max(this.presentialMax)] : []],
            adultMin: [data.adultMin, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
            adultMax: [data.adultMax, [Validators.required, Validators.pattern(/^[1-9][0-9]*$/)]],
            adultIncrementalStep: [data.adultIncrementalStep, [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.min(1), offerPresentialAdultIncrementalStepValidator]],
            adultDefault: [data.adultDefault, [Validators.required, Validators.pattern(/^[0-9]*$/), offerPresentialAdultDefaultValidator]],
            childMin: [data.childMin, [Validators.required, Validators.pattern(/^[0-9]*$/)]],
            childMax: [data.childMax, [Validators.required, Validators.pattern(/^[1-9][0-9]*$/)]],
            childIncrementalStep: [data.childIncrementalStep, [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.min(1), offerPresentialChildIncrementalStepValidator]],
            childDefault: [data.childDefault, [Validators.required, Validators.pattern(/^[0-9]*$/), offerPresentialChildDefaultValidator]]
        });
    }

    public createLocationGroup(data: Partial<OfferLocation>, addLocation : boolean = false): UntypedFormGroup {

        const control: UntypedFormGroup =  this._formBuilder.group({
            address: [{ value: data.address, disabled: false }, [Validators.required]],
            zipcode: [{ value: data.zipcode, disabled: false }, [Validators.required]],
            city: [{ value: data.city, disabled: false }, [Validators.required]],
            department: [{ value: data.department, disabled: false }, [Validators.required]],
            country: [{ value: data.country, disabled: false }, [Validators.required]],
            latitude: [{ value: data.latitude, disabled: false }, [Validators.required, Validators.pattern(/^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,})?))$/)]],
            longitude: [{ value: data.longitude, disabled: false }, [Validators.required, Validators.pattern(/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,})?))$/)]],
            inseeCode: [{ value: data.inseeCode, disabled: false }, []],
            translations: new UntypedFormArray([]),
            isMain: [data.isMain, [Validators.required]],
            providers: [data.providers ? data.providers : []],
            isArrival: [data.isArrival, [Validators.required]],
            isDeparture: [data.isDeparture, [Validators.required]],
            transports: new UntypedFormArray([]),
            position: [data.position, [Validators.required]]
        });

        if('id' in data){

            control.addControl('id', new UntypedFormControl(data.id, [Validators.required]));
        }

        // Traductions

        const translationBuilder = new TranslationBuilder(this._formBuilder);

        translationBuilder.form = control;

        translationBuilder.addItemCallback = (): UntypedFormGroup => {

            return this._formBuilder.group({
                title: [''],
                description: ['', Validators.pattern(/^(.{0,200})$/)]
            });
        };

        if (!addLocation){

            data.translations.forEach((translation: OfferLocationTranslation): void => {

                const translationControl: FormGroup = translationBuilder.addItemControl(translationBuilder.getLocaleItem(translation.locale), translation);

                if('id' in translation){

                    translationControl.addControl('id', new UntypedFormControl(translation.id, [Validators.required]));
                }
            });
        }

        else {

            translationBuilder.updateItems(this.form.get('locales').value);
        }

        this.locationTranslationBuilders.push(translationBuilder);

        // Transports

        const transportsControl: FormArray = control.get('transports') as FormArray;

        data.transports.forEach((item: OfferLocationTransport): void => {

            transportsControl.push(this.createLocationTransportGroup(item));
        });

        return control;
    }

    public createLocationTransportGroup(data: Partial<OfferLocationTransport>): UntypedFormGroup {

        const control: UntypedFormGroup = this._formBuilder.group({
            isArrival: [data.isArrival, [Validators.required]],
            isDeparture: [data.isDeparture, [Validators.required]],
            transport: [data.transport, [Validators.required]]
        });

        if('id' in data){

            control.addControl('id', new UntypedFormControl(data.id, [Validators.required]));
        }

        return control;
    }

    public isSelectedTransportType(type: TransportType): boolean {

        return this.selectedAccessTransportTypes.includes(type);
    }

    public handleTransportConfiguration(event: any): void {

        const selectedAccessTransportTypesBuffer = [...this.selectedAccessTransportTypes];

        // Mise à jour des moyens d'accès sélectionnés

        const value: TransportType = event.target.value;

        if (event.target.checked) {

            this.selectedAccessTransportTypes.push(value);

        } else {

            const index: number = this.selectedAccessTransportTypes.findIndex((item: TransportType): boolean => {

                return item === value;
            });

            this.selectedAccessTransportTypes.splice(index, 1);
        }

        // Mise à jour des données

        if(Boolean(this.selectedAccessTransportTypes.length)){

            // Au moins un type de transport est sélectionné

            if(!selectedAccessTransportTypesBuffer.length){

                // Il n'y avait pas de type de transport sélectionné avant

                this.arrivalOfferLocationControl = this.locationsControl.controls.find((control: FormGroup): boolean => {

                    return control.get('isMain').value;

                }) as FormGroup;

                this.arrivalOfferLocationControl.get(OfferLocationDirection.Arrival).patchValue(true);

                this.arrivalOfferLocationControl.get(OfferLocationDirection.Departure).patchValue(true);

                this.hydrateOfferLocationTransports(this.arrivalOfferLocationControl, OfferLocationDirection.Arrival);

                this.updateTransportDisplayState(OfferLocationDirection.Arrival, true);
            }
            else{

                // Il y avait un type de transport avant

                if(selectedAccessTransportTypesBuffer.includes(value)){

                    // On supprime le type de transport

                    this.clearOfferLocationTransportsByType(this.arrivalOfferLocationControl, value);

                    if(!this.form.get('startLocationSameAsEndLocation').value){

                        this.clearOfferLocationTransportsByType(this.departureOfferLocationControl, value);
                    }
                }

                this.hydrateOfferLocationTransportByType(this.arrivalOfferLocationControl, OfferLocationDirection.Arrival, value);

                this.updateTransportDisplayState(OfferLocationDirection.Arrival, true);

                if(!this.form.get('startLocationSameAsEndLocation').value){

                    this.hydrateOfferLocationTransportByType(this.departureOfferLocationControl, OfferLocationDirection.Departure, value);

                    this.updateTransportDisplayState(OfferLocationDirection.Departure, true);
                }
            }
        }
        else{

            // Réinitialisation des données

            this.resetTransportConfiguration(false);
        }
    }

    public handleOfferLocationTransportConfiguration(locationControl: FormGroup, direction: OfferLocationDirection): void {

        this.locationsControl.controls.forEach((control: FormGroup): void => {

            control.get(direction).patchValue(false);

            if(this.form.get('startLocationSameAsEndLocation').value && (direction === OfferLocationDirection.Arrival)){

                control.get(OfferLocationDirection.Departure).patchValue(false);
            }
        });

        locationControl.get(direction).patchValue(true);

        if(this.form.get('startLocationSameAsEndLocation').value && (direction === OfferLocationDirection.Arrival)){

            locationControl.get(OfferLocationDirection.Departure).patchValue(true);
        }

        this.locationsControl.controls.forEach((control: FormGroup): void => {

            this.clearOfferLocationTransportsByDirection(control, direction);
        });

        if(direction === OfferLocationDirection.Arrival){

            this.arrivalOfferLocationControl = locationControl;

            this.hydrateOfferLocationTransports(this.arrivalOfferLocationControl, direction);
        }

        if(direction === OfferLocationDirection.Departure){

            this.departureOfferLocationControl = locationControl;

            this.hydrateOfferLocationTransports(this.departureOfferLocationControl, direction);
        }

        this.updateTransportDisplayState(direction, true);
    }

    public handleDepartureOfferLocation(startLocationSameAsEndLocation: boolean): void {

        if (startLocationSameAsEndLocation) {

            this.locationsControl.controls.forEach((locationControl: FormGroup): void => {

                locationControl.get(OfferLocationDirection.Departure).patchValue(false);

                this.clearOfferLocationTransportsByDirection(locationControl, OfferLocationDirection.Departure);
            });

            this.arrivalOfferLocationControl.get(OfferLocationDirection.Departure).patchValue(true);

            const offerLocationTransportsControl: FormArray = this.arrivalOfferLocationControl.get('transports') as FormArray;

            offerLocationTransportsControl.controls.forEach((control: FormGroup): void => {

                control.get(OfferLocationDirection.Departure).patchValue(true);
            });

            this.departureOfferLocationControl = null;
        }
        else{

            this.departureOfferLocationControl = this.locationsControl.controls.find((control: FormGroup): boolean => {

                return control.get('isMain').value;

            }) as FormGroup;

            this.departureOfferLocationControl.get(OfferLocationDirection.Departure).patchValue(true);

            if(this.arrivalOfferLocationControl){

                if(this.arrivalOfferLocationControl !== this.departureOfferLocationControl){

                    this.arrivalOfferLocationControl.get(OfferLocationDirection.Departure).patchValue(false);
                }

                (this.arrivalOfferLocationControl.get('transports') as FormArray).controls.forEach((control: FormGroup): void => {

                    control.get(OfferLocationDirection.Departure).patchValue(false);
                });
            }

            this.hydrateOfferLocationTransports(this.departureOfferLocationControl, OfferLocationDirection.Departure);

            this.updateTransportDisplayState(OfferLocationDirection.Departure, true);
        }
    }

    public resetTransportConfiguration(resetSelectedTransportTypes: boolean): void {

        if(resetSelectedTransportTypes){

            this.selectedAccessTransportTypes.length = 0;
        }

        this.arrivalOfferLocationControl = null;

        this.departureOfferLocationControl = null;

        this.form.get('startLocationSameAsEndLocation').patchValue(true);

        this.locationsControl.controls.forEach((control: FormGroup): void => {

            control.get(OfferLocationDirection.Arrival).patchValue(false);

            control.get(OfferLocationDirection.Departure).patchValue(false);

            this.clearOfferLocationTransportsByDirection(control, OfferLocationDirection.Arrival);

            this.clearOfferLocationTransportsByDirection(control, OfferLocationDirection.Departure);
        });

        this.updateTransportDisplayState(OfferLocationDirection.Arrival, false);

        this.updateTransportDisplayState(OfferLocationDirection.Departure, false);
    }

    public hydrateOfferLocationTransports(offerLocationControl: FormGroup, direction: OfferLocationDirection): void {

        const availableTransportTypes: TransportType[] = ['train-station', 'airport'];

        availableTransportTypes.forEach((type: TransportType): void => {

            if(this.isSelectedTransportType(type) && !this.offerLocationHasTransportByDirection(offerLocationControl, direction, type)){

                (offerLocationControl.get('transports') as FormArray).push(this.createLocationTransportGroup({
                    isArrival: (direction === OfferLocationDirection.Arrival),
                    isDeparture: this.form.get('startLocationSameAsEndLocation').value ? true : (direction === OfferLocationDirection.Departure),
                    transport: {
                        id: null,
                        type: type,
                        code: null,
                        label: null,
                        latitude: null,
                        longitude: null
                    } as Transport
                }));
            }
        });
    }

    public hydrateOfferLocationTransportByType(offerLocationControl: FormGroup, direction: OfferLocationDirection, type: TransportType): void {

        if(this.isSelectedTransportType(type) && !this.offerLocationHasTransportByDirection(offerLocationControl, direction, type)){

            (offerLocationControl.get('transports') as FormArray).push(this.createLocationTransportGroup({
                isArrival: (direction === OfferLocationDirection.Arrival),
                isDeparture: this.form.get('startLocationSameAsEndLocation').value ? true : (direction === OfferLocationDirection.Departure),
                transport: {
                    id: null,
                    type: type,
                    code: null,
                    label: null,
                    latitude: null,
                    longitude: null
                } as Transport
            }));
        }
    }

    public offerLocationHasTransportByDirection(offerLocationControl: FormGroup, direction: OfferLocationDirection, type: TransportType): boolean {

        const offerLocationTransportsControl: FormArray = offerLocationControl.get('transports') as FormArray;

        return offerLocationTransportsControl.controls.some((control: FormGroup): boolean => {

            return (control.get(direction).value) && (control.get('transport').value.type === type);
        });
    }

    public clearOfferLocationTransportsByDirection(offerLocationControl: FormGroup, direction: OfferLocationDirection): void {

        const offerLocationTransportsControl: FormArray = offerLocationControl.get('transports') as FormArray;

        const items: FormGroup[] = offerLocationTransportsControl.controls.filter((control: FormGroup): boolean => {

            return !control.get(direction).value;

        }) as FormGroup[];

        (offerLocationControl.get('transports') as FormArray).clear();

        items.forEach((control: FormGroup): void => {

            (offerLocationControl.get('transports') as FormArray).push(control);
        });
    }

    public clearOfferLocationTransportsByType(offerLocationControl: FormGroup, type: TransportType): void {

        const offerLocationTransportsControl: FormArray = offerLocationControl.get('transports') as FormArray;

        const items: FormGroup[] = offerLocationTransportsControl.controls.filter((offerLocationTransport: FormGroup): boolean => {

            return offerLocationTransport.get('transport').value.type !== type;

        }) as FormGroup[];

        (offerLocationControl.get('transports') as FormArray).clear();

        items.forEach((control: FormGroup): void => {

            (offerLocationControl.get('transports') as FormArray).push(control);
        });
    }

    public updateTransportDisplayState(direction: OfferLocationDirection, displayed: boolean): void {

        this.transportDisplayedConfiguration[direction] = false;

        if(!displayed){

            return;
        }

        setTimeout((): void  => {

            this.transportDisplayedConfiguration[direction] = true;
        });
    }

    public hasLocationsWithTransportType(type: TransportType): boolean {

        return this.offer.locations.some((location: OfferLocation): boolean => {

            return location.transports.some((offerLocationTransport: OfferLocationTransport): boolean => {

                return offerLocationTransport.transport.type === type;
            });
        });
    }

    public handleTransportDescriptionControls(): void {

        (this.form.get('translations') as FormArray).controls.forEach((control: FormGroup): void => {

            if(!this.isSelectedTransportType('train-station')){

                control.get('transportArrivalTrainStationDescription').patchValue(null);
                control.get('transportDepartureTrainStationDescription').patchValue(null);
            }

            control.get('transportArrivalTrainStationDescription').updateValueAndValidity({onlySelf: true, emitEvent: false});
            control.get('transportDepartureTrainStationDescription').updateValueAndValidity({onlySelf: true, emitEvent: false});

            if(!this.isSelectedTransportType('airport')){

                control.get('transportArrivalAirportDescription').patchValue(null);
                control.get('transportDepartureAirportDescription').patchValue(null);
            }

            control.get('transportArrivalAirportDescription').updateValueAndValidity({onlySelf: true, emitEvent: false});
            control.get('transportDepartureAirportDescription').updateValueAndValidity({onlySelf: true, emitEvent: false});
        });
    }

    public locationControlUsedForTransportAccess(locationControl: AbstractControl): boolean {

        const controls: FormGroup[] = [this.arrivalOfferLocationControl, this.departureOfferLocationControl];

        return controls.includes(locationControl as FormGroup);
    }

    public compareByFormGroupPosition(a: FormGroup, b: FormGroup): boolean {

        if(!a || !b){

            return false;
        }

        return a.get('position').value === b.get('position').value;
    }

    public hydrateTransportCalculations(): void {

        this.resetTransportCalculations();

        const observables: Observable<OfferLocationTransport>[] = [];

        const offerLocationControls: FormGroup[] = [];

        if(this.arrivalOfferLocationControl){

            offerLocationControls.push(this.arrivalOfferLocationControl);
        }

        if(this.departureOfferLocationControl){

            offerLocationControls.push(this.departureOfferLocationControl);
        }

        offerLocationControls.forEach((offerLocationControl: FormGroup): void => {

            ((offerLocationControl.get('transports') as FormArray).controls as FormGroup[]).forEach((control: FormGroup): void => {

                const data: object = {
                    latitude: offerLocationControl.get('latitude').value,
                    longitude: offerLocationControl.get('longitude').value
                };

                const headers: AdditionalHeader[] = [{name: DEACTIVATE_LOADER_HEADER_IDENTIFIER, value: 1}];

                const observable: Observable<OfferLocationTransport> = this._transportService.calculateItemAPI(control.get('transport').value.id, data, headers).pipe(
                    map((item: TransportCalculation): OfferLocationTransport => {

                        return Object.assign({...control.value}, item);
                    })
                ) as Observable<OfferLocationTransport>;

                observables.push(observable);
            });
        });

        forkJoin(observables).subscribe((items: OfferLocationTransport[]): void => {

            this.transportCalculations = items;
        });
    }

    public resetTransportCalculations(): void {

        this.transportCalculations = [];
    }

    public getTransportCalculation(isArrival: boolean, isDeparture: boolean, type: TransportType): OfferLocationTransport {

        return this.transportCalculations.find((item: OfferLocationTransport): boolean => {

            const conditions: boolean[] = [
                item.isArrival === isArrival,
                item.isDeparture === isDeparture,
                item.transport.type === type
            ];

            return conditions.every((condition: boolean) => condition);
        });
    }

    public getTransportUpdatedLocationControlsFromLocationControl(locationControl: FormGroup): AbstractControl[] {

        return [
            locationControl.get('address'),
            locationControl.get('zipcode'),
            locationControl.get('city'),
            locationControl.get('department'),
            locationControl.get('country'),
            locationControl.get('latitude'),
            locationControl.get('longitude'),
            locationControl.get('inseeCode')
        ];
    }

    public resetTransportOfferLocationControlsByLocationControl(locationControl: FormGroup): void {

        if(this.arrivalOfferLocationControl && (this.arrivalOfferLocationControl === locationControl)){

            this.arrivalOfferLocationControl = null;

            // On réinitialise les données pour l'arrivée

            this.locationsControl.controls.forEach((control: FormGroup): void => {

                control.get(OfferLocationDirection.Arrival).patchValue(false);

                this.clearOfferLocationTransportsByDirection(control, OfferLocationDirection.Arrival);
            });

            this.updateTransportDisplayState(OfferLocationDirection.Arrival, false);

            // Si le début et fin de programme sont identique, on réinitialise les données pour le départ

            if(this.form.get('startLocationSameAsEndLocation').value){

                this.locationsControl.controls.forEach((control: FormGroup): void => {

                    control.get(OfferLocationDirection.Departure).patchValue(false);

                    this.clearOfferLocationTransportsByDirection(control, OfferLocationDirection.Departure);
                });

                this.updateTransportDisplayState(OfferLocationDirection.Departure, false);
            }
        }

        if(this.departureOfferLocationControl && (this.departureOfferLocationControl === locationControl)){

            this.departureOfferLocationControl = null;

            this.locationsControl.controls.forEach((control: FormGroup): void => {

                control.get(OfferLocationDirection.Departure).patchValue(false);

                this.clearOfferLocationTransportsByDirection(control, OfferLocationDirection.Departure);
            });

            this.updateTransportDisplayState(OfferLocationDirection.Departure, false);
        }
    }

    public handleCustomerTypologyType(): void {

        if(!this.customerTypologyUpdateAllowed){

            return;
        }

        const idFilter: TextFilterField = new TextFilterField('id', 'eq', this.customerTypologyControl.get('id').value);

        const params: string[] = [
            idFilter.serialize
        ];

        this._customerTypologyService.getItemsAPI(params).subscribe((data: CustomerTypology[]): void => {

            this.customerTypologyType = data[0].type;

            this.presentialControl.get('max').clearValidators();

            this.presentialControl.get('max').patchValue(null);

            if (this.customerTypologyType === 'I') {

                this.presentialControl.get('max').setValidators([Validators.required, Validators.pattern(/^[0-9]*$/), Validators.max(this.presentialMax)]);
            }

            if (this.customerTypologyType === 'G') {

                this.presentialControl.get('max').setValidators([]);
            }

            this.presentialControl.get('max').updateValueAndValidity();
        });
    }

    public indexAsString(index: number): string{

        return index.toString();
    }

    public addLocation(): void {

        const control: FormGroup = this.createLocationGroup({
            address: null,
            zipcode: null,
            city: null,
            country: null,
            department: null,
            latitude: null,
            longitude: null,
            position: this.locationsControl.controls.length + 1,
            isMain: false,
            isArrival: false,
            isDeparture: false,
            transports: [],
            providers: [],
            translations:[]
        }, true);

        this.locationsControl.push(control);

        this.getTransportUpdatedLocationControlsFromLocationControl(control).forEach((transportUpdatedLocationControl: AbstractControl): void => {

            transportUpdatedLocationControl.valueChanges.subscribe((): void => {

                this.resetTransportOfferLocationControlsByLocationControl(transportUpdatedLocationControl.parent as FormGroup);
            });
        });

        setTimeout((): void => {

            this.handleContentManagementValidators();
        });
    }

    public removeLocation(index: number): void {

        // Réinitialisation des données transport

        this.resetTransportOfferLocationControlsByLocationControl(this.locationsControl.at(index) as FormGroup);

        // Suppression de la localisation

        const translationBuilderIndex: number = this.locationTranslationBuilders.findIndex((builder: TranslationBuilder): boolean => {

            return builder.form === this.getLocationControl(index);
        });

        this.locationTranslationBuilders.splice(translationBuilderIndex, 1);

        this.locationsControl.removeAt(index);

        this.locationsControl.controls.forEach((control: UntypedFormGroup, index: number): void => {

            control.patchValue({
                position: index + 1
            });
        });

        setTimeout((): void => {

            this.handleContentManagementValidators();
        });

        if(this.locationsControl.controls.length <= 1){

            this.form.get('circuitType').patchValue('itinerant' as OfferCircuitType);
        }
    }

    public openDeleteDialog(): void {

        const title : string = this._translateService.instant('offer.delete.title.value');

        const content : string = this._translateService.instant('offer.delete.description.value');

        const dialogRef: MatDialogRef<ConfirmDialogComponent> = this._dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {
                title: title,
                content: content,
            }
        });

        dialogRef.componentInstance.confirm.subscribe((): void => {

            this.offerService.deleteItemAPI(this.offerId).subscribe((): void => {

                this._snackBar.open(this._translateService.instant('offer.form.action.delete.success.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 5000
                });

                this._router.navigate(['account/offer/list/personnal-offers']);
            });
        });
    }

    public getLocationControl(index: number): AbstractControl {

        return this.locationsControl.controls[index];
    }

    public getLocationTranslationBuilder(index: number): TranslationBuilder {

        return this.locationTranslationBuilders.find((builder: TranslationBuilder): boolean => {

            return builder.form === this.getLocationControl(index);
        });
    }

    public getTranslation(index: number): UntypedFormGroup {

        return this.translationsControl.controls[index] as UntypedFormGroup;
    }

    public redirectToList(): void {

        this._router.navigate(['account/offer/list/personnal-offers']);
    }

    public submit(saveAndRedirect: boolean, target?: ('availabilities')): void {

        this.saveAndRedirectConfiguration = {
            active: saveAndRedirect,
            target: target
        };

        this.form.get('attributes').updateValueAndValidity();

        this.formSubmitSubscription.next(this.form.value);

        this.formService.submit();
    }

    public getSortedPictureControls(control: AbstractControl): AbstractControl[] {

        return (control.get('pictures') as UntypedFormArray).controls.sort((a: UntypedFormGroup, b: UntypedFormGroup): number => {

            return a.value.position - b.value.position;
        });
    }

    public increasePicturePosition(index: number): void {

        this.offerService.displayedLocales$.getValue().forEach((locale: string): void => {

            const control: UntypedFormArray = this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray;

            this.increaseTranslationPicturePosition(control, index);

            control.controls.sort((a: UntypedFormGroup, b: UntypedFormGroup): number => {

                return a.value.position - b.value.position;
            });
        });
    }

    public increaseTranslationPicturePosition(control: AbstractControl, index: number): void {

        const groupToIncrease: UntypedFormGroup = (control as UntypedFormArray).at(index) as UntypedFormGroup;

        const currentPosition: number = groupToIncrease.value.position;

        const groupToDecrease: AbstractControl = (control as UntypedFormArray).controls.find((group: UntypedFormGroup): boolean => {

            return group.value.position === currentPosition + 1;
        });

        groupToIncrease.patchValue({
            position: currentPosition + 1
        });

        groupToDecrease.patchValue({
            position: groupToDecrease.value.position - 1
        });
    }

    public decreasePicturePosition(index: number): void {

        this.offerService.displayedLocales$.getValue().forEach((locale: string): void => {

            const control: UntypedFormArray = this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray;

            this.decreaseTranslationPicturePosition(control, index);

            control.controls.sort((a: UntypedFormGroup, b: UntypedFormGroup): number => {

                return a.value.position - b.value.position;
            });
        });
    }

    public decreaseTranslationPicturePosition(control: AbstractControl, index: number): void {

        const groupToDecrease: UntypedFormGroup = (control as UntypedFormArray).at(index) as UntypedFormGroup;

        const currentPosition: number = groupToDecrease.value.position;

        const groupToIncrease: AbstractControl = (control as UntypedFormArray).controls.find((group: UntypedFormGroup): boolean => {

            return group.value.position === currentPosition - 1;
        });

        groupToDecrease.patchValue({
            position: currentPosition - 1
        });

        groupToIncrease.patchValue({
            position: groupToIncrease.value.position + 1
        });
    }

    public isIncreasePicturePositionAllowed(index: number): boolean {

        const control: UntypedFormArray = this.translationBuilder.itemsControl.at(0).get('pictures') as UntypedFormArray;

        return this.isIncreaseTranslationPicturePositionAllowed(control, index);
    }

    public isIncreaseTranslationPicturePositionAllowed(control: AbstractControl, index: number): boolean {

        const group: UntypedFormGroup = (control as UntypedFormArray).controls[index] as UntypedFormGroup;

        const position: number = group.value.position;

        return position !== (control as UntypedFormArray).controls.length;
    }

    public isDecreasePicturePositionAllowed(index: number): boolean {

        const control: UntypedFormArray = this.translationBuilder.itemsControl.at(0).get('pictures') as UntypedFormArray;

        return this.isDecreaseTranslationPicturePositionAllowed(control, index);
    }

    public isDecreaseTranslationPicturePositionAllowed(control: AbstractControl, index: number): boolean {

        const group: UntypedFormGroup = (control as UntypedFormArray).controls[index] as UntypedFormGroup;

        const position: number = group.value.position;

        return position !== 1;
    }

    public addPicture(): void {

        this.offerService.displayedLocales$.getValue().forEach((locale: string): void => {

            const translationControl = this.translationBuilder.getItemControlByLocale(locale);

            this.addTranslationPicture(translationControl.get('pictures'));
        });

        this.translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

            translationControl.get('pictures').updateValueAndValidity();
        });

        const sourcePicturesControl: UntypedFormArray = this.translationBuilder.itemsControl.at(0).get('pictures') as UntypedFormArray;

        const index: number = sourcePicturesControl.length - 1;

        const sourcePictureControl: UntypedFormGroup = sourcePicturesControl.at(index) as UntypedFormGroup;

        sourcePictureControl.get('copyright').valueChanges.subscribe((): void => {

            if(this.isTranslationPictureType('dissociated')){

                return;
            }

            setTimeout((): void => {

                const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                    return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
                });

                locales.forEach((locale: string): void => {

                    const destinationPicturesControl: UntypedFormArray = (this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray);

                    const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                    if(destinationPictureControl){

                        destinationPictureControl.get('copyright').patchValue(sourcePictureControl.get('copyright').value);
                    }
                });

                this.translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                    translationControl.get('pictures').updateValueAndValidity();
                });
            });
        });

        sourcePictureControl.get('image').valueChanges.subscribe((data: { image: { image } }): void => {

            if(this.isTranslationPictureType('dissociated')){

                return;
            }

            setTimeout((): void => {

                if(!data.image){

                    return;
                }

                const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                    return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
                });

                locales.forEach((locale: string): void => {

                    const destinationPicturesControl: UntypedFormArray = (this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray);

                    const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                    if(destinationPictureControl){

                        this._imageService.getCloneImage(sourcePictureControl.get('image').get('image').value).subscribe((cloneImage: Image): void => {

                            destinationPictureControl.get('image').get('image').patchValue(cloneImage);

                            this.translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                                translationControl.get('pictures').updateValueAndValidity();
                            });
                        });
                    }
                });
            });
        });
    }

    public addTranslationPicture(control: AbstractControl): void {

        const position: number = (control.value as []).length + 1;

        (control as UntypedFormArray).push(
            this._formBuilder.group({
                copyright: ['', [Validators.required]],
                image: this._formBuilder.group({
                    image: [null, [Validators.required]]
                }),
                position: [position, [Validators.required]]
            })
        );

        setTimeout((): void => {

            this.handleContentManagementValidators();
        });
    }

    public removePicture(index: number): void {

        this.offerService.displayedLocales$.getValue().forEach((locale: string): void => {

            const control: UntypedFormArray = this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray;

            this.removeTranslationPicture(control, index);
        });
    }

    public removeTranslationPicture(control, index) {

        control.removeAt(index);

        const groups: UntypedFormGroup[] = ((control as UntypedFormArray).controls as UntypedFormGroup[]).filter((group: UntypedFormGroup): boolean => {

            const item: OfferTranslationPicture = group.value;

            return item.position > (index + 1);
        });

        groups.forEach((group: UntypedFormGroup): void => {

            group.patchValue({
                position: group.value.position - 1
            });
        });

        setTimeout((): void => {

            this.handleContentManagementValidators();
        });
    }

    public handleRemovePictureImage(sourcePictureControl: AbstractControl, index: number): void {

        sourcePictureControl.get('copyright').valueChanges.subscribe((): void => {

            if(this.isTranslationPictureType('dissociated')){

                return;
            }

            setTimeout((): void => {

                const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                    return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
                });

                locales.forEach((locale: string): void => {

                    const destinationPicturesControl: UntypedFormArray = (this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray);

                    const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                    if(destinationPictureControl){

                        destinationPictureControl.get('copyright').patchValue(sourcePictureControl.get('copyright').value);
                    }
                });

                this.translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                    translationControl.get('pictures').updateValueAndValidity();
                });
            });
        });

        sourcePictureControl.get('image').get('image').valueChanges.subscribe((data: { image }): void => {

            if(this.isTranslationPictureType('dissociated')){

                return;
            }

            setTimeout((): void => {

                if(!data){

                    return;
                }

                const locales: string[] = this.offerService.displayedLocales$.getValue().filter((locale: string): boolean => {

                    return this.translationBuilder.itemsControl.at(0).get('locale').value !== locale;
                });

                locales.forEach((locale: string): void => {

                    const destinationPicturesControl: UntypedFormArray = (this.translationBuilder.getItemControlByLocale(locale).get('pictures') as UntypedFormArray);

                    const destinationPictureControl: UntypedFormGroup = destinationPicturesControl.at(index) as UntypedFormGroup;

                    if(destinationPictureControl){

                        this._imageService.getCloneImage(sourcePictureControl.get('image').get('image').value).subscribe((cloneImage: Image): void => {

                            destinationPictureControl.get('image').get('image').patchValue(cloneImage);

                            this.translationsControl.controls.forEach((translationControl: UntypedFormGroup): void => {

                                translationControl.get('pictures').updateValueAndValidity();
                            });
                        });
                    }
                });
            });
        });
    }

    public openLeaveWithoutSubmitDialog(): void {

        const dialogRef: MatDialogRef<ConfirmDialogComponent> = this._dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {
                title: this._translateService.instant('form.leaveWithoutSubmit.value'),
                content: this._translateService.instant('form.leaveWithoutSubmit.description.value')
            }
        });

        dialogRef.componentInstance.confirm.subscribe((): void => {

            this.redirectToList();
        });
    }

    public hasAccessDelete(): boolean {

        return this.user.accesses.some((access : Access): boolean => {

            return access.tag === 'OFFER_DELETE_IS_MINE';
        });
    }

    public isSelectedLocale(locale: LocaleItem): boolean {

        return this.form.get('locales').value.includes(locale.id);
    }

    public isSelectedSourceLocale(locale: LocaleItem): boolean {

        return this.automaticTranslationSourceLocale === locale.id;
    }

    public isSelectedDestinationLocale(locale: LocaleItem): boolean {

        return this.automaticTranslationDestinationLocales.includes(locale.id);
    }

    public isSelectedGiftVoucherType(type: VoucherType): boolean {

        return this.giftVoucherControl.get('types').value.includes(type);
    }

    public handleGiftVoucherType(event: any): void {

        const control: UntypedFormControl = this.giftVoucherControl.get('types') as UntypedFormControl;

        const controlValue: VoucherType[] = control.value;

        const value: VoucherType = event.target.value;

        if (event.target.checked) {

            controlValue.push(value);
        } else {

            const index: number = controlValue.findIndex((i: VoucherType): boolean => {

                return i === value;
            });

            controlValue.splice(index, 1);
        }

        control.patchValue(controlValue);
    }

    public isTranslationPictureType(value: TranslationPictureType): boolean {

        return this.form.get('translationPictureType').value === value;
    }

    public scrollToBottomOfElement(element: ElementRef): void {

        if(!element || !element.nativeElement){

            return;
        }

        element.nativeElement.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
        });
    }

    public getOfferDurationById(id: number): OfferDuration {

        return this.offerDurations.find((item: OfferDuration): boolean => {

            return item.id === id;

        }) as OfferDuration;
    }

    public getPanel(tag: FormPanelTag): FormPanel<FormPanelTag> {

        return this.panels.find((panel: FormPanel<FormPanelTag>): boolean => {

            return panel.tag === tag;
        });
    }

    public isValidPanel(tag: FormPanelTag): boolean {

        return this.getPanel(tag).valid;
    }

    public isOpenPanel(tag: FormPanelTag): boolean {

        return this.getPanel(tag).open;
    }

    public togglePanelOpening(tag: FormPanelTag): void {

        const panel: FormPanel<FormPanelTag> = this.getPanel(tag);

        panel.open = !panel.open;
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }

    get presentialControl(): UntypedFormGroup {

        return this.form.get('presential') as UntypedFormGroup;
    }

    get groupDurationControl(): UntypedFormGroup {

        return this.form.get('duration') as UntypedFormGroup;
    }

    get programsControl(): UntypedFormArray {

        return this.form.get('programs') as UntypedFormArray;
    }

    get trueIncludedControl(): UntypedFormArray {

        return this.form.get('trueIncluded') as UntypedFormArray;
    }

    get falseIncludedControl(): UntypedFormArray {

        return this.form.get('falseIncluded') as UntypedFormArray;
    }

    get giftVoucherControl(): UntypedFormGroup {

        return this.form.get('giftVoucher') as UntypedFormGroup;
    }

    get includedControl(): UntypedFormArray {

        return this.form.get('included') as UntypedFormArray;
    }

    get interestsControl(): UntypedFormArray {

        return this.form.get('interests') as UntypedFormArray;
    }

    get locationsControl(): UntypedFormArray {

        return this.form.get('locations') as UntypedFormArray;
    }

    get providerLocations(): UntypedFormControl {

        return this.form.get('providerLocations') as UntypedFormControl;
    }

    get translationsControl(): UntypedFormArray {

        return this.form.get('translations') as UntypedFormArray;
    }

    get configurationControl(): UntypedFormGroup {

        return this.form.get('configuration') as UntypedFormGroup;
    }

    get seoControl(): UntypedFormGroup {

        return this.form.get('seo') as UntypedFormGroup;
    }

    get attributesControl(): UntypedFormArray {

        return this.form.get('attributes') as UntypedFormArray;
    }

    get providerSocietiesControl(): UntypedFormControl {

        return this.form.get('providerSocieties') as UntypedFormControl;
    }

    get restrictedSocietiesControl(): UntypedFormControl {

        return this.form.get('restrictedSocieties') as UntypedFormControl;
    }

    get customerTypologyControl(): UntypedFormGroup {

        return this.form.get('customerTypology') as UntypedFormGroup;
    }

    get localeId(): string {

        return this._translateService.currentLang;
    }

    get offerGiftVoucherTypes(): GiftVoucherType[] {

        return OFFER_GIFTVOUCHER_TYPES;
    }

    get hasAccessGiftVoucher(): boolean {

        return this.user.accesses.some((access: Access): boolean => {

            return access.tag === 'ONLINE_SALE';
        });
    }

    get hasAccessMultipleGeolocation(): boolean {
        const accesses = this.user.accesses.filter((access: Access) => {
            return access.tag == 'MULTIPLE_GEOLOCATION';
        });

        return (accesses.length > 0);
    }

    get geolocationIsAllowed(): boolean {

        return this.hasAccessMultipleGeolocation && this.limitProgram === OFFER_WITHOUT_NIGHT;
    }

    get salesPitchEditorConfig(): CkeditorConfig {

        return {
            id: 'salesPitch',
            editor: this.editor,
            attrs: {
                required: false
            }
        }
    }

    get descriptionEditorConfig(): CkeditorConfig {

        return {
            id: 'description',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 7000
            }
        }
    }

    get accommodationEditorConfig(): CkeditorConfig {

        return {
            id: 'accommodation',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 1000
            }
        }
    }

    get transportArrivalTrainStationDescriptionEditorConfig(): CkeditorConfig {

        return {
            id: 'transportArrivalTrainStationDescription',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 1000
            }
        }
    }

    get transportArrivalAirportDescriptionEditorConfig(): CkeditorConfig {

        return {
            id: 'transportArrivalAirportDescription',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 1000
            }
        }
    }

    get transportDepartureTrainStationDescriptionEditorConfig(): CkeditorConfig {

        return {
            id: 'transportDepartureTrainStationDescription',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 1000
            }
        }
    }

    get transportDepartureAirportDescriptionEditorConfig(): CkeditorConfig {

        return {
            id: 'transportDepartureAirportDescription',
            editor: this.editor,
            attrs: {
                required: false,
                maxLength: 1000
            }
        }
    }

    get picturesConfig(): ImageConfig {

        return {
            id: 'image',
            gallery_context: 'offer_picture',
            required: false,
            uploadApiUrl: this.apiService.getApiUrl(false, true),
            options: {
                enableTitle: false,
                enableSubtitle: false,
                enableAlt: false,
                enableLink: false,
                enableTargetBlank: false,
                label: this._translateService.instant('offer.form.fields.picture.value')
            },
        }
    }

    get formTabValidationItemsCallback(): () => FormTabValidationItem[] {

        return (): FormTabValidationItem[] => {

            const items: Partial<FormTabValidationItem>[] = [];

            // Données générales

            const generalDataControls: AbstractControl[] = [
                this.form.get('publics'),
                this.form.get('minChildrenAge'),
                this.form.get('maxChildrenAge'),
                this.form.get('reference'),
                this.form.get('locales'),
                this.form.get('optinAutomaticTranslation'),
                this.form.get('published'),
                this.form.get('isRestricted'),
                this.form.get('restrictedSocieties'),
                this.form.get('presential'),
                this.form.get('duration')
            ];

            if(this.customerTypologyUpdateAllowed){

                generalDataControls.push(this.customerTypologyControl.get('id'));
            }

            items.push({
                tag: 'generalData',
                controls: generalDataControls
            });

            // Gestion de contenu

            items.push({
                tag: 'contentManagement',
                controls: [
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('name')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('teaser')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('description')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('accommodation')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('pictures')),
                    this.form.get('interests'),
                    this.form.get('included'),
                    this.form.get('trueIncluded'),
                    this.form.get('falseIncluded')
                ]
            });

            // Données programme

            items.push({
                tag: 'programData',
                controls: [
                    this.form.get('limitLocation'),
                    this.form.get('programs')
                ]
            });

            // Données caractéristiques

            items.push({
                tag: 'characteristicData',
                controls: [
                    this.form.get('customerTypology').get('type'),
                    this.attributesFormReference,
                    this.form.get('attributes')
                ]
            });

            // Données prestataires

            items.push({
                tag: 'providerData',
                controls: [
                    this.form.get('providerSocieties')
                ]
            });

            // Données localisations

            items.push({
                tag: 'locationData',
                controls: [
                    this.form.get('enableMultipleMainLocation'),
                    this.form.get('locations')
                ]
            });

            // Accès

            items.push({
                tag: 'access',
                controls: [
                    this.transportOfferLocationsControl.get('arrival'),
                    this.transportOfferLocationsControl.get('departure'),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('transportArrivalTrainStationDescription')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('transportArrivalAirportDescription')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('transportDepartureTrainStationDescription')),
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('transportDepartureAirportDescription'))
                ],
                badge: {
                    displayed: false,
                    label: 'new.value'
                }
            });

            // Gestion du SEO

            items.push({
                tag: 'seoManagement',
                controls: [
                    this.form.get('seo')
                ]
            });

            // Argumentaire de vente

            items.push({
                tag: 'internalComments',
                controls: [
                    ...(this.form.get('translations') as UntypedFormArray).controls.map((group: UntypedFormGroup) => group.get('salesPitch')),
                    this.form.get('isOnAlert'),
                    this.form.get('commentAlert')
                ]
            });

            /**

             // Options

             items.push({
                tag: 'options',
                controls: [
                    this.form.get('options')
                ]
            });

             **/

            // Données tarifaires

            items.push({
                tag: 'pricingData',
                controls: [
                    this.form.get('timezone'),
                    this.form.get('onRequest'),
                    this.form.get('currency'),
                    this.form.get('internalStartFromPriceTTC'),
                    this.form.get('startFromPriceBasedOnParticipantCount'),
                    this.form.get('priceCalculationAutomatic'),
                    this.form.get('vatPercent'),
                    this.form.get('allowBookingRequest'),
                    this.form.get('markup'),
                    this.form.get('displayPrice')
                ]
            });

            // Bon cadeaux

            if(this.hasAccessGiftVoucher){

                items.push({
                    tag: 'giftVoucherData',
                    controls: [
                        this.form.get('giftVoucher').get('types'),
                        this.form.get('giftVoucher').get('childPriceTTC'),
                        this.form.get('giftVoucher').get('adultPriceTTC'),
                    ]
                });
            }

            return items.map((item: Partial<FormTabValidationItem>, index: number): FormTabValidationItem => {

                return Object.assign(item, {
                    position: index + 1
                } as FormTabValidationItem);
            });
        };
    }

    get selectedLocales(): string[] {

        if(!this.form || !this.form.get('locales')){

            return [];
        }

        return this.form.get('locales').value;
    }

    get defaultGiftVoucher(): OfferGiftVoucherConfiguration {

        return {
            id: null,
            enable: false,
            isPhysical: false,
            isDematerialized: false,
            adultPriceTTC: null,
            childPriceTTC: null
        };
    }

    get defaultOnlineSale(): OfferOnlineSaleConfiguration {

        return {
            id: null,
            enable: false,
            stockManagementType: 'dissociated'
        };
    }

    get allRestrictedSocieties(): Society[] {

        if(!this.form.get('isRestricted').value){

            return [];
        }

        const items: Society[] = [];

        // Récupération du créateur d'offre

        items.push(this.society);

        // Récupération des prestataires sélectionnés

        items.push(...this.providerSocietiesControl.value as Society[]);

        // Récupération des distributeurs sélectionnés

        items.push(...this.restrictedSocietiesControl.value as Society[]);

        return [...new Map(items.map((item: Society) => [item.id, item])).values()];
    }

    get hasAccessAutomaticTranslation(): boolean {

        return this.user.accesses.some((access: Access): boolean => {

            return access.tag === 'AUTOMATIC_TRANSLATION';
        });
    }

    get customerTypologyUpdateAllowed(): boolean {

        if(this.isOrchestra){

            return false;
        }

        return ('fromDuplication' in this._activatedRoute.snapshot.queryParams) && Boolean(parseInt(this._activatedRoute.snapshot.queryParams['fromDuplication']));
    }

    get isPublishable(): boolean {

        if(this.offer.published === 'published'){

            return true;
        }

        return this.society.countAllowedPublishedOffers === null || (this.society.countAllowedPublishedOffers - this.society.countPublishedOffers) > 0;
    }

    get isOrchestra(): boolean {

        return this.configurationControl.get('orchestra').value;
    }

    get isIndividualCustomerTypologyAvailable(): boolean {

        return this.customerTypologies.some((item: CustomerTypology): boolean => {

            return item.type === 'I';
        });
    }

    get isStartLocationSameAsEndLocation(): boolean {

        const hasLocationWithTransport: boolean = this.offer.locations.some((location: OfferLocation): boolean => {

            return Boolean(location.transports.length);
        });

        if(!hasLocationWithTransport){

            return true;
        }

        return this.offer.locations.some((location: OfferLocation): boolean => {

            return location.isArrival && location.isDeparture && location.transports.every((offerLocationTransport: OfferLocationTransport): boolean => {

                return offerLocationTransport.isArrival && offerLocationTransport.isDeparture;
            });
        });
    }

    get arrivalOfferLocation(): OfferLocation {

        return this.offer.locations.find((location: OfferLocation): boolean => {

            return location.isArrival;

        }) || null;
    }

    get departureOfferLocation(): OfferLocation {

        return this.offer.locations.find((location: OfferLocation): boolean => {

            return location.isDeparture;

        }) || null;
    }
}
